import * as ie from "react";
import jn, { forwardRef as Io, useContext as jo } from "react";
const dr = {
  black: "#000",
  white: "#fff"
}, Je = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Ze = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, Qe = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, er = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, rr = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
}, sr = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Mo = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function pr(e) {
  let r = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    r += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + r + " for the full message.";
}
const No = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pr
}, Symbol.toStringTag, { value: "Module" })), Do = "$$material";
function te() {
  return te = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var t in n) ({}).hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, te.apply(null, arguments);
}
function qe(e, r) {
  if (e == null) return {};
  var n = {};
  for (var t in e) if ({}.hasOwnProperty.call(e, t)) {
    if (r.indexOf(t) !== -1) continue;
    n[t] = e[t];
  }
  return n;
}
function Fo(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Lo(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Wo = /* @__PURE__ */ (function() {
  function e(n) {
    var t = this;
    this._insertTag = function(o) {
      var i;
      t.tags.length === 0 ? t.insertionPoint ? i = t.insertionPoint.nextSibling : t.prepend ? i = t.container.firstChild : i = t.before : i = t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(o, i), t.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(t) {
    t.forEach(this._insertTag);
  }, r.insert = function(t) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Lo(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = Fo(o);
      try {
        i.insertRule(t, i.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(t));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(t) {
      var o;
      return (o = t.parentNode) == null ? void 0 : o.removeChild(t);
    }), this.tags = [], this.ctr = 0;
  }, e;
})(), Se = "-ms-", $r = "-moz-", J = "-webkit-", Mn = "comm", bt = "rule", Et = "decl", Yo = "@import", Nn = "@keyframes", zo = "@layer", qo = Math.abs, jr = String.fromCharCode, Uo = Object.assign;
function Bo(e, r) {
  return Ee(e, 0) ^ 45 ? (((r << 2 ^ Ee(e, 0)) << 2 ^ Ee(e, 1)) << 2 ^ Ee(e, 2)) << 2 ^ Ee(e, 3) : 0;
}
function Dn(e) {
  return e.trim();
}
function Vo(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function Z(e, r, n) {
  return e.replace(r, n);
}
function pt(e, r) {
  return e.indexOf(r);
}
function Ee(e, r) {
  return e.charCodeAt(r) | 0;
}
function yr(e, r, n) {
  return e.slice(r, n);
}
function Me(e) {
  return e.length;
}
function _t(e) {
  return e.length;
}
function Sr(e, r) {
  return r.push(e), e;
}
function Go(e, r) {
  return e.map(r).join("");
}
var Mr = 1, or = 1, Fn = 0, we = 0, ge = 0, ar = "";
function Nr(e, r, n, t, o, i, s) {
  return { value: e, root: r, parent: n, type: t, props: o, children: i, line: Mr, column: or, length: s, return: "" };
}
function cr(e, r) {
  return Uo(Nr("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Ko() {
  return ge;
}
function Ho() {
  return ge = we > 0 ? Ee(ar, --we) : 0, or--, ge === 10 && (or = 1, Mr--), ge;
}
function Ce() {
  return ge = we < Fn ? Ee(ar, we++) : 0, or++, ge === 10 && (or = 1, Mr++), ge;
}
function De() {
  return Ee(ar, we);
}
function wr() {
  return we;
}
function gr(e, r) {
  return yr(ar, e, r);
}
function mr(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Ln(e) {
  return Mr = or = 1, Fn = Me(ar = e), we = 0, [];
}
function Wn(e) {
  return ar = "", e;
}
function Pr(e) {
  return Dn(gr(we - 1, yt(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Xo(e) {
  for (; (ge = De()) && ge < 33; )
    Ce();
  return mr(e) > 2 || mr(ge) > 3 ? "" : " ";
}
function Jo(e, r) {
  for (; --r && Ce() && !(ge < 48 || ge > 102 || ge > 57 && ge < 65 || ge > 70 && ge < 97); )
    ;
  return gr(e, wr() + (r < 6 && De() == 32 && Ce() == 32));
}
function yt(e) {
  for (; Ce(); )
    switch (ge) {
      // ] ) " '
      case e:
        return we;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && yt(ge);
        break;
      // (
      case 40:
        e === 41 && yt(e);
        break;
      // \
      case 92:
        Ce();
        break;
    }
  return we;
}
function Zo(e, r) {
  for (; Ce() && e + ge !== 57; )
    if (e + ge === 84 && De() === 47)
      break;
  return "/*" + gr(r, we - 1) + "*" + jr(e === 47 ? e : Ce());
}
function Qo(e) {
  for (; !mr(De()); )
    Ce();
  return gr(e, we);
}
function ei(e) {
  return Wn(Cr("", null, null, null, [""], e = Ln(e), 0, [0], e));
}
function Cr(e, r, n, t, o, i, s, u, l) {
  for (var d = 0, y = 0, m = s, h = 0, x = 0, g = 0, a = 1, b = 1, R = 1, C = 0, k = "", M = o, S = i, q = t, f = k; b; )
    switch (g = C, C = Ce()) {
      // (
      case 40:
        if (g != 108 && Ee(f, m - 1) == 58) {
          pt(f += Z(Pr(C), "&", "&\f"), "&\f") != -1 && (R = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        f += Pr(C);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        f += Xo(g);
        break;
      // \
      case 92:
        f += Jo(wr() - 1, 7);
        continue;
      // /
      case 47:
        switch (De()) {
          case 42:
          case 47:
            Sr(ri(Zo(Ce(), wr()), r, n), l);
            break;
          default:
            f += "/";
        }
        break;
      // {
      case 123 * a:
        u[d++] = Me(f) * R;
      // } ; \0
      case 125 * a:
      case 59:
      case 0:
        switch (C) {
          // \0 }
          case 0:
          case 125:
            b = 0;
          // ;
          case 59 + y:
            R == -1 && (f = Z(f, /\f/g, "")), x > 0 && Me(f) - m && Sr(x > 32 ? Bt(f + ";", t, n, m - 1) : Bt(Z(f, " ", "") + ";", t, n, m - 2), l);
            break;
          // @ ;
          case 59:
            f += ";";
          // { rule/at-rule
          default:
            if (Sr(q = Ut(f, r, n, d, y, o, u, k, M = [], S = [], m), i), C === 123)
              if (y === 0)
                Cr(f, r, q, q, M, i, m, u, S);
              else
                switch (h === 99 && Ee(f, 3) === 110 ? 100 : h) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Cr(e, q, q, t && Sr(Ut(e, q, q, 0, 0, o, u, k, o, M = [], m), S), o, S, m, u, t ? M : S);
                    break;
                  default:
                    Cr(f, q, q, q, [""], S, 0, u, S);
                }
        }
        d = y = x = 0, a = R = 1, k = f = "", m = s;
        break;
      // :
      case 58:
        m = 1 + Me(f), x = g;
      default:
        if (a < 1) {
          if (C == 123)
            --a;
          else if (C == 125 && a++ == 0 && Ho() == 125)
            continue;
        }
        switch (f += jr(C), C * a) {
          // &
          case 38:
            R = y > 0 ? 1 : (f += "\f", -1);
            break;
          // ,
          case 44:
            u[d++] = (Me(f) - 1) * R, R = 1;
            break;
          // @
          case 64:
            De() === 45 && (f += Pr(Ce())), h = De(), y = m = Me(k = f += Qo(wr())), C++;
            break;
          // -
          case 45:
            g === 45 && Me(f) == 2 && (a = 0);
        }
    }
  return i;
}
function Ut(e, r, n, t, o, i, s, u, l, d, y) {
  for (var m = o - 1, h = o === 0 ? i : [""], x = _t(h), g = 0, a = 0, b = 0; g < t; ++g)
    for (var R = 0, C = yr(e, m + 1, m = qo(a = s[g])), k = e; R < x; ++R)
      (k = Dn(a > 0 ? h[R] + " " + C : Z(C, /&\f/g, h[R]))) && (l[b++] = k);
  return Nr(e, r, n, o === 0 ? bt : u, l, d, y);
}
function ri(e, r, n) {
  return Nr(e, r, n, Mn, jr(Ko()), yr(e, 2, -2), 0);
}
function Bt(e, r, n, t) {
  return Nr(e, r, n, Et, yr(e, 0, t), yr(e, t + 1, -1), t);
}
function tr(e, r) {
  for (var n = "", t = _t(e), o = 0; o < t; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function ti(e, r, n, t) {
  switch (e.type) {
    case zo:
      if (e.children.length) break;
    case Yo:
    case Et:
      return e.return = e.return || e.value;
    case Mn:
      return "";
    case Nn:
      return e.return = e.value + "{" + tr(e.children, t) + "}";
    case bt:
      e.value = e.props.join(",");
  }
  return Me(n = tr(e.children, t)) ? e.return = e.value + "{" + n + "}" : "";
}
function ni(e) {
  var r = _t(e);
  return function(n, t, o, i) {
    for (var s = "", u = 0; u < r; u++)
      s += e[u](n, t, o, i) || "";
    return s;
  };
}
function oi(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Yn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var ii = function(r, n, t) {
  for (var o = 0, i = 0; o = i, i = De(), o === 38 && i === 12 && (n[t] = 1), !mr(i); )
    Ce();
  return gr(r, we);
}, ai = function(r, n) {
  var t = -1, o = 44;
  do
    switch (mr(o)) {
      case 0:
        o === 38 && De() === 12 && (n[t] = 1), r[t] += ii(we - 1, n, t);
        break;
      case 2:
        r[t] += Pr(o);
        break;
      case 4:
        if (o === 44) {
          r[++t] = De() === 58 ? "&\f" : "", n[t] = r[t].length;
          break;
        }
      // fallthrough
      default:
        r[t] += jr(o);
    }
  while (o = Ce());
  return r;
}, si = function(r, n) {
  return Wn(ai(Ln(r), n));
}, Vt = /* @__PURE__ */ new WeakMap(), ci = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, t = r.parent, o = r.column === t.column && r.line === t.line; t.type !== "rule"; )
      if (t = t.parent, !t) return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Vt.get(t)) && !o) {
      Vt.set(r, !0);
      for (var i = [], s = si(n, i), u = t.props, l = 0, d = 0; l < s.length; l++)
        for (var y = 0; y < u.length; y++, d++)
          r.props[d] = i[l] ? s[l].replace(/&\f/g, u[y]) : u[y] + " " + s[l];
    }
  }
}, ui = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function zn(e, r) {
  switch (Bo(e, r)) {
    // color-adjust
    case 5103:
      return J + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return J + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return J + e + $r + e + Se + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return J + e + Se + e + e;
    // order
    case 6165:
      return J + e + Se + "flex-" + e + e;
    // align-items
    case 5187:
      return J + e + Z(e, /(\w+).+(:[^]+)/, J + "box-$1$2" + Se + "flex-$1$2") + e;
    // align-self
    case 5443:
      return J + e + Se + "flex-item-" + Z(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return J + e + Se + "flex-line-pack" + Z(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return J + e + Se + Z(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return J + e + Se + Z(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return J + "box-" + Z(e, "-grow", "") + J + e + Se + Z(e, "grow", "positive") + e;
    // transition
    case 4554:
      return J + Z(e, /([^-])(transform)/g, "$1" + J + "$2") + e;
    // cursor
    case 6187:
      return Z(Z(Z(e, /(zoom-|grab)/, J + "$1"), /(image-set)/, J + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return Z(e, /(image-set\([^]*)/, J + "$1$`$1");
    // justify-content
    case 4968:
      return Z(Z(e, /(.+:)(flex-)?(.*)/, J + "box-pack:$3" + Se + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + J + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Z(e, /(.+)-inline(.+)/, J + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Me(e) - 1 - r > 6) switch (Ee(e, r + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (Ee(e, r + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return Z(e, /(.+:)(.+)-([^]+)/, "$1" + J + "$2-$3$1" + $r + (Ee(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~pt(e, "stretch") ? zn(Z(e, "stretch", "fill-available"), r) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (Ee(e, r + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (Ee(e, Me(e) - 3 - (~pt(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return Z(e, ":", ":" + J) + e;
        // (inline-)?fl(e)x
        case 101:
          return Z(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + J + (Ee(e, 14) === 45 ? "inline-" : "") + "box$3$1" + J + "$2$3$1" + Se + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (Ee(e, r + 11)) {
        // vertical-l(r)
        case 114:
          return J + e + Se + Z(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return J + e + Se + Z(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return J + e + Se + Z(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return J + e + Se + e + e;
  }
  return e;
}
var fi = function(r, n, t, o) {
  if (r.length > -1 && !r.return) switch (r.type) {
    case Et:
      r.return = zn(r.value, r.length);
      break;
    case Nn:
      return tr([cr(r, {
        value: Z(r.value, "@", "@" + J)
      })], o);
    case bt:
      if (r.length) return Go(r.props, function(i) {
        switch (Vo(i, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return tr([cr(r, {
              props: [Z(i, /:(read-\w+)/, ":" + $r + "$1")]
            })], o);
          // :placeholder
          case "::placeholder":
            return tr([cr(r, {
              props: [Z(i, /:(plac\w+)/, ":" + J + "input-$1")]
            }), cr(r, {
              props: [Z(i, /:(plac\w+)/, ":" + $r + "$1")]
            }), cr(r, {
              props: [Z(i, /:(plac\w+)/, Se + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, li = [fi], qn = function(r) {
  var n = r.key;
  if (n === "css") {
    var t = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(t, function(a) {
      var b = a.getAttribute("data-emotion");
      b.indexOf(" ") !== -1 && (document.head.appendChild(a), a.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || li, i = {}, s, u = [];
  s = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(a) {
      for (var b = a.getAttribute("data-emotion").split(" "), R = 1; R < b.length; R++)
        i[b[R]] = !0;
      u.push(a);
    }
  );
  var l, d = [ci, ui];
  {
    var y, m = [ti, oi(function(a) {
      y.insert(a);
    })], h = ni(d.concat(o, m)), x = function(b) {
      return tr(ei(b), h);
    };
    l = function(b, R, C, k) {
      y = C, x(b ? b + "{" + R.styles + "}" : R.styles), k && (g.inserted[R.name] = !0);
    };
  }
  var g = {
    key: n,
    sheet: new Wo({
      key: n,
      container: s,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: l
  };
  return g.sheet.hydrate(u), g;
}, sc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function St(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ue(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var r = e.default;
  if (typeof r == "function") {
    var n = function t() {
      var o = !1;
      try {
        o = this instanceof t;
      } catch {
      }
      return o ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    n.prototype = r.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(t) {
    var o = Object.getOwnPropertyDescriptor(e, t);
    Object.defineProperty(n, t, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[t];
      }
    });
  }), n;
}
var xr = { exports: {} }, ee = {};
var Gt;
function di() {
  if (Gt) return ee;
  Gt = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, n = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, t = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, o = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, i = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, s = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, u = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, d = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, y = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, m = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, h = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, x = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, g = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, a = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, b = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, R = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, C = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function k(S) {
    if (typeof S == "object" && S !== null) {
      var q = S.$$typeof;
      switch (q) {
        case r:
          switch (S = S.type, S) {
            case l:
            case d:
            case t:
            case i:
            case o:
            case m:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case u:
                case y:
                case g:
                case x:
                case s:
                  return S;
                default:
                  return q;
              }
          }
        case n:
          return q;
      }
    }
  }
  function M(S) {
    return k(S) === d;
  }
  return ee.AsyncMode = l, ee.ConcurrentMode = d, ee.ContextConsumer = u, ee.ContextProvider = s, ee.Element = r, ee.ForwardRef = y, ee.Fragment = t, ee.Lazy = g, ee.Memo = x, ee.Portal = n, ee.Profiler = i, ee.StrictMode = o, ee.Suspense = m, ee.isAsyncMode = function(S) {
    return M(S) || k(S) === l;
  }, ee.isConcurrentMode = M, ee.isContextConsumer = function(S) {
    return k(S) === u;
  }, ee.isContextProvider = function(S) {
    return k(S) === s;
  }, ee.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === r;
  }, ee.isForwardRef = function(S) {
    return k(S) === y;
  }, ee.isFragment = function(S) {
    return k(S) === t;
  }, ee.isLazy = function(S) {
    return k(S) === g;
  }, ee.isMemo = function(S) {
    return k(S) === x;
  }, ee.isPortal = function(S) {
    return k(S) === n;
  }, ee.isProfiler = function(S) {
    return k(S) === i;
  }, ee.isStrictMode = function(S) {
    return k(S) === o;
  }, ee.isSuspense = function(S) {
    return k(S) === m;
  }, ee.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === t || S === d || S === i || S === o || S === m || S === h || typeof S == "object" && S !== null && (S.$$typeof === g || S.$$typeof === x || S.$$typeof === s || S.$$typeof === u || S.$$typeof === y || S.$$typeof === b || S.$$typeof === R || S.$$typeof === C || S.$$typeof === a);
  }, ee.typeOf = k, ee;
}
var re = {};
var Kt;
function pi() {
  return Kt || (Kt = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, n = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, t = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, o = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, i = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, s = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, u = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, d = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, y = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, m = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, h = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, x = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, g = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, a = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, b = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, R = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, C = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
    function k(O) {
      return typeof O == "string" || typeof O == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      O === t || O === d || O === i || O === o || O === m || O === h || typeof O == "object" && O !== null && (O.$$typeof === g || O.$$typeof === x || O.$$typeof === s || O.$$typeof === u || O.$$typeof === y || O.$$typeof === b || O.$$typeof === R || O.$$typeof === C || O.$$typeof === a);
    }
    function M(O) {
      if (typeof O == "object" && O !== null) {
        var be = O.$$typeof;
        switch (be) {
          case r:
            var Fe = O.type;
            switch (Fe) {
              case l:
              case d:
              case t:
              case i:
              case o:
              case m:
                return Fe;
              default:
                var Ie = Fe && Fe.$$typeof;
                switch (Ie) {
                  case u:
                  case y:
                  case g:
                  case x:
                  case s:
                    return Ie;
                  default:
                    return be;
                }
            }
          case n:
            return be;
        }
      }
    }
    var S = l, q = d, f = u, p = s, E = r, T = y, A = t, se = g, W = x, U = n, ve = i, V = o, X = m, Te = !1;
    function _e(O) {
      return Te || (Te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), _(O) || M(O) === l;
    }
    function _(O) {
      return M(O) === d;
    }
    function P(O) {
      return M(O) === u;
    }
    function Y(O) {
      return M(O) === s;
    }
    function F(O) {
      return typeof O == "object" && O !== null && O.$$typeof === r;
    }
    function N(O) {
      return M(O) === y;
    }
    function B(O) {
      return M(O) === t;
    }
    function I(O) {
      return M(O) === g;
    }
    function D(O) {
      return M(O) === x;
    }
    function z(O) {
      return M(O) === n;
    }
    function G(O) {
      return M(O) === i;
    }
    function $(O) {
      return M(O) === o;
    }
    function ce(O) {
      return M(O) === m;
    }
    re.AsyncMode = S, re.ConcurrentMode = q, re.ContextConsumer = f, re.ContextProvider = p, re.Element = E, re.ForwardRef = T, re.Fragment = A, re.Lazy = se, re.Memo = W, re.Portal = U, re.Profiler = ve, re.StrictMode = V, re.Suspense = X, re.isAsyncMode = _e, re.isConcurrentMode = _, re.isContextConsumer = P, re.isContextProvider = Y, re.isElement = F, re.isForwardRef = N, re.isFragment = B, re.isLazy = I, re.isMemo = D, re.isPortal = z, re.isProfiler = G, re.isStrictMode = $, re.isSuspense = ce, re.isValidElementType = k, re.typeOf = M;
  })()), re;
}
var Ht;
function xt() {
  return Ht || (Ht = 1, process.env.NODE_ENV === "production" ? xr.exports = di() : xr.exports = pi()), xr.exports;
}
var et, Xt;
function yi() {
  if (Xt) return et;
  Xt = 1;
  var e = xt(), r = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, t = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = t, i[e.Memo] = o;
  function s(g) {
    return e.isMemo(g) ? o : i[g.$$typeof] || r;
  }
  var u = Object.defineProperty, l = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, y = Object.getOwnPropertyDescriptor, m = Object.getPrototypeOf, h = Object.prototype;
  function x(g, a, b) {
    if (typeof a != "string") {
      if (h) {
        var R = m(a);
        R && R !== h && x(g, R, b);
      }
      var C = l(a);
      d && (C = C.concat(d(a)));
      for (var k = s(g), M = s(a), S = 0; S < C.length; ++S) {
        var q = C[S];
        if (!n[q] && !(b && b[q]) && !(M && M[q]) && !(k && k[q])) {
          var f = y(a, q);
          try {
            u(g, q, f);
          } catch {
          }
        }
      }
    }
    return g;
  }
  return et = x, et;
}
var mi = yi();
const cc = /* @__PURE__ */ St(mi);
var hi = !0;
function Un(e, r, n) {
  var t = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : o && (t += o + " ");
  }), t;
}
var Tt = function(r, n, t) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (t === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  hi === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Ot = function(r, n, t) {
  Tt(r, n, t);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function gi(e) {
  for (var r = 0, n, t = 0, o = e.length; o >= 4; ++t, o -= 4)
    n = e.charCodeAt(t) & 255 | (e.charCodeAt(++t) & 255) << 8 | (e.charCodeAt(++t) & 255) << 16 | (e.charCodeAt(++t) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(t + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(t + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(t) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var vi = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, bi = /[A-Z]|^ms/g, Ei = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Bn = function(r) {
  return r.charCodeAt(1) === 45;
}, Jt = function(r) {
  return r != null && typeof r != "boolean";
}, rt = /* @__PURE__ */ Yn(function(e) {
  return Bn(e) ? e : e.replace(bi, "-$&").toLowerCase();
}), Zt = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Ei, function(t, o, i) {
          return Ne = {
            name: o,
            styles: i,
            next: Ne
          }, o;
        });
  }
  return vi[r] !== 1 && !Bn(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function hr(e, r, n) {
  if (n == null)
    return "";
  var t = n;
  if (t.__emotion_styles !== void 0)
    return t;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return Ne = {
          name: o.name,
          styles: o.styles,
          next: Ne
        }, o.name;
      var i = n;
      if (i.styles !== void 0) {
        var s = i.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Ne = {
              name: s.name,
              styles: s.styles,
              next: Ne
            }, s = s.next;
        var u = i.styles + ";";
        return u;
      }
      return _i(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var l = Ne, d = n(e);
        return Ne = l, hr(e, r, d);
      }
      break;
    }
  }
  var y = n;
  if (r == null)
    return y;
  var m = r[y];
  return m !== void 0 ? m : y;
}
function _i(e, r, n) {
  var t = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      t += hr(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var s = n[i];
      if (typeof s != "object") {
        var u = s;
        r != null && r[u] !== void 0 ? t += i + "{" + r[u] + "}" : Jt(u) && (t += rt(i) + ":" + Zt(i, u) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (r == null || r[s[0]] === void 0))
        for (var l = 0; l < s.length; l++)
          Jt(s[l]) && (t += rt(i) + ":" + Zt(i, s[l]) + ";");
      else {
        var d = hr(e, r, s);
        switch (i) {
          case "animation":
          case "animationName": {
            t += rt(i) + ":" + d + ";";
            break;
          }
          default:
            t += i + "{" + d + "}";
        }
      }
    }
  return t;
}
var Qt = /label:\s*([^\s;{]+)\s*(;|$)/g, Ne;
function vr(e, r, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var t = !0, o = "";
  Ne = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    t = !1, o += hr(n, r, i);
  else {
    var s = i;
    o += s[0];
  }
  for (var u = 1; u < e.length; u++)
    if (o += hr(n, r, e[u]), t) {
      var l = i;
      o += l[u];
    }
  Qt.lastIndex = 0;
  for (var d = "", y; (y = Qt.exec(o)) !== null; )
    d += "-" + y[1];
  var m = gi(o) + d;
  return {
    name: m,
    styles: o,
    next: Ne
  };
}
var Si = function(r) {
  return r();
}, Vn = ie.useInsertionEffect ? ie.useInsertionEffect : !1, Gn = Vn || Si, en = Vn || ie.useLayoutEffect, Kn = /* @__PURE__ */ ie.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ qn({
    key: "css"
  }) : null
), xi = Kn.Provider, Rt = function(r) {
  return /* @__PURE__ */ Io(function(n, t) {
    var o = jo(Kn);
    return r(n, o, t);
  });
}, Dr = /* @__PURE__ */ ie.createContext({}), wt = {}.hasOwnProperty, mt = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Ti = function(r, n) {
  var t = {};
  for (var o in n)
    wt.call(n, o) && (t[o] = n[o]);
  return t[mt] = r, t;
}, Oi = function(r) {
  var n = r.cache, t = r.serialized, o = r.isStringTag;
  return Tt(n, t, o), Gn(function() {
    return Ot(n, t, o);
  }), null;
}, Ri = /* @__PURE__ */ Rt(function(e, r, n) {
  var t = e.css;
  typeof t == "string" && r.registered[t] !== void 0 && (t = r.registered[t]);
  var o = e[mt], i = [t], s = "";
  typeof e.className == "string" ? s = Un(r.registered, i, e.className) : e.className != null && (s = e.className + " ");
  var u = vr(i, void 0, ie.useContext(Dr));
  s += r.key + "-" + u.name;
  var l = {};
  for (var d in e)
    wt.call(e, d) && d !== "css" && d !== mt && (l[d] = e[d]);
  return l.className = s, n && (l.ref = n), /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(Oi, {
    cache: r,
    serialized: u,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ ie.createElement(o, l));
}), wi = Ri, rn = function(r, n) {
  var t = arguments;
  if (n == null || !wt.call(n, "css"))
    return ie.createElement.apply(void 0, t);
  var o = t.length, i = new Array(o);
  i[0] = wi, i[1] = Ti(r, n);
  for (var s = 2; s < o; s++)
    i[s] = t[s];
  return ie.createElement.apply(null, i);
};
(function(e) {
  var r;
  r || (r = e.JSX || (e.JSX = {}));
})(rn || (rn = {}));
var Pi = /* @__PURE__ */ Rt(function(e, r) {
  var n = e.styles, t = vr([n], void 0, ie.useContext(Dr)), o = ie.useRef();
  return en(function() {
    var i = r.key + "-global", s = new r.sheet.constructor({
      key: i,
      nonce: r.sheet.nonce,
      container: r.sheet.container,
      speedy: r.sheet.isSpeedy
    }), u = !1, l = document.querySelector('style[data-emotion="' + i + " " + t.name + '"]');
    return r.sheet.tags.length && (s.before = r.sheet.tags[0]), l !== null && (u = !0, l.setAttribute("data-emotion", i), s.hydrate([l])), o.current = [s, u], function() {
      s.flush();
    };
  }, [r]), en(function() {
    var i = o.current, s = i[0], u = i[1];
    if (u) {
      i[1] = !1;
      return;
    }
    if (t.next !== void 0 && Ot(r, t.next, !0), s.tags.length) {
      var l = s.tags[s.tags.length - 1].nextElementSibling;
      s.before = l, s.flush();
    }
    r.insert("", t, s, !1);
  }, [r, t.name]), null;
});
function Hn() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  return vr(r);
}
function Ci() {
  var e = Hn.apply(void 0, arguments), r = "animation-" + e.name;
  return {
    name: r,
    styles: "@keyframes " + r + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var $i = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ai = /* @__PURE__ */ Yn(
  function(e) {
    return $i.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), ki = Ai, Ii = function(r) {
  return r !== "theme";
}, tn = function(r) {
  return typeof r == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  r.charCodeAt(0) > 96 ? ki : Ii;
}, nn = function(r, n, t) {
  var o;
  if (n) {
    var i = n.shouldForwardProp;
    o = r.__emotion_forwardProp && i ? function(s) {
      return r.__emotion_forwardProp(s) && i(s);
    } : i;
  }
  return typeof o != "function" && t && (o = r.__emotion_forwardProp), o;
}, ji = function(r) {
  var n = r.cache, t = r.serialized, o = r.isStringTag;
  return Tt(n, t, o), Gn(function() {
    return Ot(n, t, o);
  }), null;
}, Mi = function e(r, n) {
  var t = r.__emotion_real === r, o = t && r.__emotion_base || r, i, s;
  n !== void 0 && (i = n.label, s = n.target);
  var u = nn(r, n, t), l = u || tn(o), d = !l("as");
  return function() {
    var y = arguments, m = t && r.__emotion_styles !== void 0 ? r.__emotion_styles.slice(0) : [];
    if (i !== void 0 && m.push("label:" + i + ";"), y[0] == null || y[0].raw === void 0)
      m.push.apply(m, y);
    else {
      var h = y[0];
      m.push(h[0]);
      for (var x = y.length, g = 1; g < x; g++)
        m.push(y[g], h[g]);
    }
    var a = Rt(function(b, R, C) {
      var k = d && b.as || o, M = "", S = [], q = b;
      if (b.theme == null) {
        q = {};
        for (var f in b)
          q[f] = b[f];
        q.theme = ie.useContext(Dr);
      }
      typeof b.className == "string" ? M = Un(R.registered, S, b.className) : b.className != null && (M = b.className + " ");
      var p = vr(m.concat(S), R.registered, q);
      M += R.key + "-" + p.name, s !== void 0 && (M += " " + s);
      var E = d && u === void 0 ? tn(k) : l, T = {};
      for (var A in b)
        d && A === "as" || E(A) && (T[A] = b[A]);
      return T.className = M, C && (T.ref = C), /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(ji, {
        cache: R,
        serialized: p,
        isStringTag: typeof k == "string"
      }), /* @__PURE__ */ ie.createElement(k, T));
    });
    return a.displayName = i !== void 0 ? i : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", a.defaultProps = r.defaultProps, a.__emotion_real = a, a.__emotion_base = o, a.__emotion_styles = m, a.__emotion_forwardProp = u, Object.defineProperty(a, "toString", {
      value: function() {
        return "." + s;
      }
    }), a.withComponent = function(b, R) {
      var C = e(b, te({}, n, R, {
        shouldForwardProp: nn(a, R, !0)
      }));
      return C.apply(void 0, m);
    }, a;
  };
}, Ni = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], ht = Mi.bind(null);
Ni.forEach(function(e) {
  ht[e] = ht(e);
});
var Tr = { exports: {} };
var tt, on;
function Di() {
  if (on) return tt;
  on = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function t(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, u = 0; u < 10; u++)
        s["_" + String.fromCharCode(u)] = u;
      var l = Object.getOwnPropertyNames(s).map(function(y) {
        return s[y];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(y) {
        d[y] = y;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return tt = o() ? Object.assign : function(i, s) {
    for (var u, l = t(i), d, y = 1; y < arguments.length; y++) {
      u = Object(arguments[y]);
      for (var m in u)
        r.call(u, m) && (l[m] = u[m]);
      if (e) {
        d = e(u);
        for (var h = 0; h < d.length; h++)
          n.call(u, d[h]) && (l[d[h]] = u[d[h]]);
      }
    }
    return l;
  }, tt;
}
var nt, an;
function Pt() {
  if (an) return nt;
  an = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return nt = e, nt;
}
var ot, sn;
function Xn() {
  return sn || (sn = 1, ot = Function.call.bind(Object.prototype.hasOwnProperty)), ot;
}
var it, cn;
function Fi() {
  if (cn) return it;
  cn = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = /* @__PURE__ */ Pt(), n = {}, t = /* @__PURE__ */ Xn();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, u, l, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var y in i)
        if (t(i, y)) {
          var m;
          try {
            if (typeof i[y] != "function") {
              var h = Error(
                (l || "React class") + ": " + u + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            m = i[y](s, y, l, u, null, r);
          } catch (g) {
            m = g;
          }
          if (m && !(m instanceof Error) && e(
            (l || "React class") + ": type specification of " + u + " `" + y + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in n)) {
            n[m.message] = !0;
            var x = d ? d() : "";
            e(
              "Failed " + u + " type: " + m.message + (x ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, it = o, it;
}
var at, un;
function Li() {
  if (un) return at;
  un = 1;
  var e = xt(), r = Di(), n = /* @__PURE__ */ Pt(), t = /* @__PURE__ */ Xn(), o = /* @__PURE__ */ Fi(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(u) {
    var l = "Warning: " + u;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return at = function(u, l) {
    var d = typeof Symbol == "function" && Symbol.iterator, y = "@@iterator";
    function m(_) {
      var P = _ && (d && _[d] || _[y]);
      if (typeof P == "function")
        return P;
    }
    var h = "<<anonymous>>", x = {
      array: R("array"),
      bigint: R("bigint"),
      bool: R("boolean"),
      func: R("function"),
      number: R("number"),
      object: R("object"),
      string: R("string"),
      symbol: R("symbol"),
      any: C(),
      arrayOf: k,
      element: M(),
      elementType: S(),
      instanceOf: q,
      node: T(),
      objectOf: p,
      oneOf: f,
      oneOfType: E,
      shape: se,
      exact: W
    };
    function g(_, P) {
      return _ === P ? _ !== 0 || 1 / _ === 1 / P : _ !== _ && P !== P;
    }
    function a(_, P) {
      this.message = _, this.data = P && typeof P == "object" ? P : {}, this.stack = "";
    }
    a.prototype = Error.prototype;
    function b(_) {
      if (process.env.NODE_ENV !== "production")
        var P = {}, Y = 0;
      function F(B, I, D, z, G, $, ce) {
        if (z = z || h, $ = $ || D, ce !== n) {
          if (l) {
            var O = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw O.name = "Invariant Violation", O;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var be = z + ":" + D;
            !P[be] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + $ + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), P[be] = !0, Y++);
          }
        }
        return I[D] == null ? B ? I[D] === null ? new a("The " + G + " `" + $ + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new a("The " + G + " `" + $ + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : _(I, D, z, G, $);
      }
      var N = F.bind(null, !1);
      return N.isRequired = F.bind(null, !0), N;
    }
    function R(_) {
      function P(Y, F, N, B, I, D) {
        var z = Y[F], G = V(z);
        if (G !== _) {
          var $ = X(z);
          return new a(
            "Invalid " + B + " `" + I + "` of type " + ("`" + $ + "` supplied to `" + N + "`, expected ") + ("`" + _ + "`."),
            { expectedType: _ }
          );
        }
        return null;
      }
      return b(P);
    }
    function C() {
      return b(s);
    }
    function k(_) {
      function P(Y, F, N, B, I) {
        if (typeof _ != "function")
          return new a("Property `" + I + "` of component `" + N + "` has invalid PropType notation inside arrayOf.");
        var D = Y[F];
        if (!Array.isArray(D)) {
          var z = V(D);
          return new a("Invalid " + B + " `" + I + "` of type " + ("`" + z + "` supplied to `" + N + "`, expected an array."));
        }
        for (var G = 0; G < D.length; G++) {
          var $ = _(D, G, N, B, I + "[" + G + "]", n);
          if ($ instanceof Error)
            return $;
        }
        return null;
      }
      return b(P);
    }
    function M() {
      function _(P, Y, F, N, B) {
        var I = P[Y];
        if (!u(I)) {
          var D = V(I);
          return new a("Invalid " + N + " `" + B + "` of type " + ("`" + D + "` supplied to `" + F + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(_);
    }
    function S() {
      function _(P, Y, F, N, B) {
        var I = P[Y];
        if (!e.isValidElementType(I)) {
          var D = V(I);
          return new a("Invalid " + N + " `" + B + "` of type " + ("`" + D + "` supplied to `" + F + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(_);
    }
    function q(_) {
      function P(Y, F, N, B, I) {
        if (!(Y[F] instanceof _)) {
          var D = _.name || h, z = _e(Y[F]);
          return new a("Invalid " + B + " `" + I + "` of type " + ("`" + z + "` supplied to `" + N + "`, expected ") + ("instance of `" + D + "`."));
        }
        return null;
      }
      return b(P);
    }
    function f(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function P(Y, F, N, B, I) {
        for (var D = Y[F], z = 0; z < _.length; z++)
          if (g(D, _[z]))
            return null;
        var G = JSON.stringify(_, function(ce, O) {
          var be = X(O);
          return be === "symbol" ? String(O) : O;
        });
        return new a("Invalid " + B + " `" + I + "` of value `" + String(D) + "` " + ("supplied to `" + N + "`, expected one of " + G + "."));
      }
      return b(P);
    }
    function p(_) {
      function P(Y, F, N, B, I) {
        if (typeof _ != "function")
          return new a("Property `" + I + "` of component `" + N + "` has invalid PropType notation inside objectOf.");
        var D = Y[F], z = V(D);
        if (z !== "object")
          return new a("Invalid " + B + " `" + I + "` of type " + ("`" + z + "` supplied to `" + N + "`, expected an object."));
        for (var G in D)
          if (t(D, G)) {
            var $ = _(D, G, N, B, I + "." + G, n);
            if ($ instanceof Error)
              return $;
          }
        return null;
      }
      return b(P);
    }
    function E(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var P = 0; P < _.length; P++) {
        var Y = _[P];
        if (typeof Y != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Te(Y) + " at index " + P + "."
          ), s;
      }
      function F(N, B, I, D, z) {
        for (var G = [], $ = 0; $ < _.length; $++) {
          var ce = _[$], O = ce(N, B, I, D, z, n);
          if (O == null)
            return null;
          O.data && t(O.data, "expectedType") && G.push(O.data.expectedType);
        }
        var be = G.length > 0 ? ", expected one of type [" + G.join(", ") + "]" : "";
        return new a("Invalid " + D + " `" + z + "` supplied to " + ("`" + I + "`" + be + "."));
      }
      return b(F);
    }
    function T() {
      function _(P, Y, F, N, B) {
        return U(P[Y]) ? null : new a("Invalid " + N + " `" + B + "` supplied to " + ("`" + F + "`, expected a ReactNode."));
      }
      return b(_);
    }
    function A(_, P, Y, F, N) {
      return new a(
        (_ || "React class") + ": " + P + " type `" + Y + "." + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + N + "`."
      );
    }
    function se(_) {
      function P(Y, F, N, B, I) {
        var D = Y[F], z = V(D);
        if (z !== "object")
          return new a("Invalid " + B + " `" + I + "` of type `" + z + "` " + ("supplied to `" + N + "`, expected `object`."));
        for (var G in _) {
          var $ = _[G];
          if (typeof $ != "function")
            return A(N, B, I, G, X($));
          var ce = $(D, G, N, B, I + "." + G, n);
          if (ce)
            return ce;
        }
        return null;
      }
      return b(P);
    }
    function W(_) {
      function P(Y, F, N, B, I) {
        var D = Y[F], z = V(D);
        if (z !== "object")
          return new a("Invalid " + B + " `" + I + "` of type `" + z + "` " + ("supplied to `" + N + "`, expected `object`."));
        var G = r({}, Y[F], _);
        for (var $ in G) {
          var ce = _[$];
          if (t(_, $) && typeof ce != "function")
            return A(N, B, I, $, X(ce));
          if (!ce)
            return new a(
              "Invalid " + B + " `" + I + "` key `" + $ + "` supplied to `" + N + "`.\nBad object: " + JSON.stringify(Y[F], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(_), null, "  ")
            );
          var O = ce(D, $, N, B, I + "." + $, n);
          if (O)
            return O;
        }
        return null;
      }
      return b(P);
    }
    function U(_) {
      switch (typeof _) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !_;
        case "object":
          if (Array.isArray(_))
            return _.every(U);
          if (_ === null || u(_))
            return !0;
          var P = m(_);
          if (P) {
            var Y = P.call(_), F;
            if (P !== _.entries) {
              for (; !(F = Y.next()).done; )
                if (!U(F.value))
                  return !1;
            } else
              for (; !(F = Y.next()).done; ) {
                var N = F.value;
                if (N && !U(N[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ve(_, P) {
      return _ === "symbol" ? !0 : P ? P["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && P instanceof Symbol : !1;
    }
    function V(_) {
      var P = typeof _;
      return Array.isArray(_) ? "array" : _ instanceof RegExp ? "object" : ve(P, _) ? "symbol" : P;
    }
    function X(_) {
      if (typeof _ > "u" || _ === null)
        return "" + _;
      var P = V(_);
      if (P === "object") {
        if (_ instanceof Date)
          return "date";
        if (_ instanceof RegExp)
          return "regexp";
      }
      return P;
    }
    function Te(_) {
      var P = X(_);
      switch (P) {
        case "array":
        case "object":
          return "an " + P;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + P;
        default:
          return P;
      }
    }
    function _e(_) {
      return !_.constructor || !_.constructor.name ? h : _.constructor.name;
    }
    return x.checkPropTypes = o, x.resetWarningCache = o.resetWarningCache, x.PropTypes = x, x;
  }, at;
}
var st, fn;
function Wi() {
  if (fn) return st;
  fn = 1;
  var e = /* @__PURE__ */ Pt();
  function r() {
  }
  function n() {
  }
  return n.resetWarningCache = r, st = function() {
    function t(s, u, l, d, y, m) {
      if (m !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    t.isRequired = t;
    function o() {
      return t;
    }
    var i = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: o,
      element: t,
      elementType: t,
      instanceOf: o,
      node: t,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: r
    };
    return i.PropTypes = i, i;
  }, st;
}
var ln;
function Yi() {
  if (ln) return Tr.exports;
  if (ln = 1, process.env.NODE_ENV !== "production") {
    var e = xt(), r = !0;
    Tr.exports = /* @__PURE__ */ Li()(e.isElement, r);
  } else
    Tr.exports = /* @__PURE__ */ Wi()();
  return Tr.exports;
}
var zi = /* @__PURE__ */ Yi();
const L = /* @__PURE__ */ St(zi);
var Or = { exports: {} }, ur = {};
var dn;
function qi() {
  if (dn) return ur;
  dn = 1;
  var e = jn, r = /* @__PURE__ */ Symbol.for("react.element"), n = /* @__PURE__ */ Symbol.for("react.fragment"), t = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, l, d) {
    var y, m = {}, h = null, x = null;
    d !== void 0 && (h = "" + d), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (x = l.ref);
    for (y in l) t.call(l, y) && !i.hasOwnProperty(y) && (m[y] = l[y]);
    if (u && u.defaultProps) for (y in l = u.defaultProps, l) m[y] === void 0 && (m[y] = l[y]);
    return { $$typeof: r, type: u, key: h, ref: x, props: m, _owner: o.current };
  }
  return ur.Fragment = n, ur.jsx = s, ur.jsxs = s, ur;
}
var fr = {};
var pn;
function Ui() {
  return pn || (pn = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = jn, r = /* @__PURE__ */ Symbol.for("react.element"), n = /* @__PURE__ */ Symbol.for("react.portal"), t = /* @__PURE__ */ Symbol.for("react.fragment"), o = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), u = /* @__PURE__ */ Symbol.for("react.context"), l = /* @__PURE__ */ Symbol.for("react.forward_ref"), d = /* @__PURE__ */ Symbol.for("react.suspense"), y = /* @__PURE__ */ Symbol.for("react.suspense_list"), m = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), x = /* @__PURE__ */ Symbol.for("react.offscreen"), g = Symbol.iterator, a = "@@iterator";
    function b(c) {
      if (c === null || typeof c != "object")
        return null;
      var v = g && c[g] || c[a];
      return typeof v == "function" ? v : null;
    }
    var R = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(c) {
      {
        for (var v = arguments.length, w = new Array(v > 1 ? v - 1 : 0), j = 1; j < v; j++)
          w[j - 1] = arguments[j];
        k("error", c, w);
      }
    }
    function k(c, v, w) {
      {
        var j = R.ReactDebugCurrentFrame, Q = j.getStackAddendum();
        Q !== "" && (v += "%s", w = w.concat([Q]));
        var ae = w.map(function(H) {
          return String(H);
        });
        ae.unshift("Warning: " + v), Function.prototype.apply.call(console[c], console, ae);
      }
    }
    var M = !1, S = !1, q = !1, f = !1, p = !1, E;
    E = /* @__PURE__ */ Symbol.for("react.module.reference");
    function T(c) {
      return !!(typeof c == "string" || typeof c == "function" || c === t || c === i || p || c === o || c === d || c === y || f || c === x || M || S || q || typeof c == "object" && c !== null && (c.$$typeof === h || c.$$typeof === m || c.$$typeof === s || c.$$typeof === u || c.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      c.$$typeof === E || c.getModuleId !== void 0));
    }
    function A(c, v, w) {
      var j = c.displayName;
      if (j)
        return j;
      var Q = v.displayName || v.name || "";
      return Q !== "" ? w + "(" + Q + ")" : w;
    }
    function se(c) {
      return c.displayName || "Context";
    }
    function W(c) {
      if (c == null)
        return null;
      if (typeof c.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof c == "function")
        return c.displayName || c.name || null;
      if (typeof c == "string")
        return c;
      switch (c) {
        case t:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case d:
          return "Suspense";
        case y:
          return "SuspenseList";
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case u:
            var v = c;
            return se(v) + ".Consumer";
          case s:
            var w = c;
            return se(w._context) + ".Provider";
          case l:
            return A(c, c.render, "ForwardRef");
          case m:
            var j = c.displayName || null;
            return j !== null ? j : W(c.type) || "Memo";
          case h: {
            var Q = c, ae = Q._payload, H = Q._init;
            try {
              return W(H(ae));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, ve = 0, V, X, Te, _e, _, P, Y;
    function F() {
    }
    F.__reactDisabledLog = !0;
    function N() {
      {
        if (ve === 0) {
          V = console.log, X = console.info, Te = console.warn, _e = console.error, _ = console.group, P = console.groupCollapsed, Y = console.groupEnd;
          var c = {
            configurable: !0,
            enumerable: !0,
            value: F,
            writable: !0
          };
          Object.defineProperties(console, {
            info: c,
            log: c,
            warn: c,
            error: c,
            group: c,
            groupCollapsed: c,
            groupEnd: c
          });
        }
        ve++;
      }
    }
    function B() {
      {
        if (ve--, ve === 0) {
          var c = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, c, {
              value: V
            }),
            info: U({}, c, {
              value: X
            }),
            warn: U({}, c, {
              value: Te
            }),
            error: U({}, c, {
              value: _e
            }),
            group: U({}, c, {
              value: _
            }),
            groupCollapsed: U({}, c, {
              value: P
            }),
            groupEnd: U({}, c, {
              value: Y
            })
          });
        }
        ve < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var I = R.ReactCurrentDispatcher, D;
    function z(c, v, w) {
      {
        if (D === void 0)
          try {
            throw Error();
          } catch (Q) {
            var j = Q.stack.trim().match(/\n( *(at )?)/);
            D = j && j[1] || "";
          }
        return `
` + D + c;
      }
    }
    var G = !1, $;
    {
      var ce = typeof WeakMap == "function" ? WeakMap : Map;
      $ = new ce();
    }
    function O(c, v) {
      if (!c || G)
        return "";
      {
        var w = $.get(c);
        if (w !== void 0)
          return w;
      }
      var j;
      G = !0;
      var Q = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ae;
      ae = I.current, I.current = null, N();
      try {
        if (v) {
          var H = function() {
            throw Error();
          };
          if (Object.defineProperty(H.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(H, []);
            } catch (Re) {
              j = Re;
            }
            Reflect.construct(c, [], H);
          } else {
            try {
              H.call();
            } catch (Re) {
              j = Re;
            }
            c.call(H.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Re) {
            j = Re;
          }
          c();
        }
      } catch (Re) {
        if (Re && j && typeof Re.stack == "string") {
          for (var K = Re.stack.split(`
`), xe = j.stack.split(`
`), pe = K.length - 1, he = xe.length - 1; pe >= 1 && he >= 0 && K[pe] !== xe[he]; )
            he--;
          for (; pe >= 1 && he >= 0; pe--, he--)
            if (K[pe] !== xe[he]) {
              if (pe !== 1 || he !== 1)
                do
                  if (pe--, he--, he < 0 || K[pe] !== xe[he]) {
                    var $e = `
` + K[pe].replace(" at new ", " at ");
                    return c.displayName && $e.includes("<anonymous>") && ($e = $e.replace("<anonymous>", c.displayName)), typeof c == "function" && $.set(c, $e), $e;
                  }
                while (pe >= 1 && he >= 0);
              break;
            }
        }
      } finally {
        G = !1, I.current = ae, B(), Error.prepareStackTrace = Q;
      }
      var Xe = c ? c.displayName || c.name : "", Ve = Xe ? z(Xe) : "";
      return typeof c == "function" && $.set(c, Ve), Ve;
    }
    function be(c, v, w) {
      return O(c, !1);
    }
    function Fe(c) {
      var v = c.prototype;
      return !!(v && v.isReactComponent);
    }
    function Ie(c, v, w) {
      if (c == null)
        return "";
      if (typeof c == "function")
        return O(c, Fe(c));
      if (typeof c == "string")
        return z(c);
      switch (c) {
        case d:
          return z("Suspense");
        case y:
          return z("SuspenseList");
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case l:
            return be(c.render);
          case m:
            return Ie(c.type, v, w);
          case h: {
            var j = c, Q = j._payload, ae = j._init;
            try {
              return Ie(ae(Q), v, w);
            } catch {
            }
          }
        }
      return "";
    }
    var me = Object.prototype.hasOwnProperty, Oe = {}, Le = R.ReactDebugCurrentFrame;
    function We(c) {
      if (c) {
        var v = c._owner, w = Ie(c.type, c._source, v ? v.type : null);
        Le.setExtraStackFrame(w);
      } else
        Le.setExtraStackFrame(null);
    }
    function Gr(c, v, w, j, Q) {
      {
        var ae = Function.call.bind(me);
        for (var H in c)
          if (ae(c, H)) {
            var K = void 0;
            try {
              if (typeof c[H] != "function") {
                var xe = Error((j || "React class") + ": " + w + " type `" + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[H] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw xe.name = "Invariant Violation", xe;
              }
              K = c[H](v, H, j, w, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (pe) {
              K = pe;
            }
            K && !(K instanceof Error) && (We(Q), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", j || "React class", w, H, typeof K), We(null)), K instanceof Error && !(K.message in Oe) && (Oe[K.message] = !0, We(Q), C("Failed %s type: %s", w, K.message), We(null));
          }
      }
    }
    var Kr = Array.isArray;
    function Hr(c) {
      return Kr(c);
    }
    function po(c) {
      {
        var v = typeof Symbol == "function" && Symbol.toStringTag, w = v && c[Symbol.toStringTag] || c.constructor.name || "Object";
        return w;
      }
    }
    function yo(c) {
      try {
        return kt(c), !1;
      } catch {
        return !0;
      }
    }
    function kt(c) {
      return "" + c;
    }
    function It(c) {
      if (yo(c))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", po(c)), kt(c);
    }
    var jt = R.ReactCurrentOwner, mo = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Mt, Nt;
    function ho(c) {
      if (me.call(c, "ref")) {
        var v = Object.getOwnPropertyDescriptor(c, "ref").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return c.ref !== void 0;
    }
    function go(c) {
      if (me.call(c, "key")) {
        var v = Object.getOwnPropertyDescriptor(c, "key").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return c.key !== void 0;
    }
    function vo(c, v) {
      typeof c.ref == "string" && jt.current;
    }
    function bo(c, v) {
      {
        var w = function() {
          Mt || (Mt = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        w.isReactWarning = !0, Object.defineProperty(c, "key", {
          get: w,
          configurable: !0
        });
      }
    }
    function Eo(c, v) {
      {
        var w = function() {
          Nt || (Nt = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        w.isReactWarning = !0, Object.defineProperty(c, "ref", {
          get: w,
          configurable: !0
        });
      }
    }
    var _o = function(c, v, w, j, Q, ae, H) {
      var K = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: c,
        key: v,
        ref: w,
        props: H,
        // Record the component responsible for creating this element.
        _owner: ae
      };
      return K._store = {}, Object.defineProperty(K._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(K, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: j
      }), Object.defineProperty(K, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Q
      }), Object.freeze && (Object.freeze(K.props), Object.freeze(K)), K;
    };
    function So(c, v, w, j, Q) {
      {
        var ae, H = {}, K = null, xe = null;
        w !== void 0 && (It(w), K = "" + w), go(v) && (It(v.key), K = "" + v.key), ho(v) && (xe = v.ref, vo(v, Q));
        for (ae in v)
          me.call(v, ae) && !mo.hasOwnProperty(ae) && (H[ae] = v[ae]);
        if (c && c.defaultProps) {
          var pe = c.defaultProps;
          for (ae in pe)
            H[ae] === void 0 && (H[ae] = pe[ae]);
        }
        if (K || xe) {
          var he = typeof c == "function" ? c.displayName || c.name || "Unknown" : c;
          K && bo(H, he), xe && Eo(H, he);
        }
        return _o(c, K, xe, Q, j, jt.current, H);
      }
    }
    var Xr = R.ReactCurrentOwner, Dt = R.ReactDebugCurrentFrame;
    function He(c) {
      if (c) {
        var v = c._owner, w = Ie(c.type, c._source, v ? v.type : null);
        Dt.setExtraStackFrame(w);
      } else
        Dt.setExtraStackFrame(null);
    }
    var Jr;
    Jr = !1;
    function Zr(c) {
      return typeof c == "object" && c !== null && c.$$typeof === r;
    }
    function Ft() {
      {
        if (Xr.current) {
          var c = W(Xr.current.type);
          if (c)
            return `

Check the render method of \`` + c + "`.";
        }
        return "";
      }
    }
    function xo(c) {
      return "";
    }
    var Lt = {};
    function To(c) {
      {
        var v = Ft();
        if (!v) {
          var w = typeof c == "string" ? c : c.displayName || c.name;
          w && (v = `

Check the top-level render call using <` + w + ">.");
        }
        return v;
      }
    }
    function Wt(c, v) {
      {
        if (!c._store || c._store.validated || c.key != null)
          return;
        c._store.validated = !0;
        var w = To(v);
        if (Lt[w])
          return;
        Lt[w] = !0;
        var j = "";
        c && c._owner && c._owner !== Xr.current && (j = " It was passed a child from " + W(c._owner.type) + "."), He(c), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', w, j), He(null);
      }
    }
    function Yt(c, v) {
      {
        if (typeof c != "object")
          return;
        if (Hr(c))
          for (var w = 0; w < c.length; w++) {
            var j = c[w];
            Zr(j) && Wt(j, v);
          }
        else if (Zr(c))
          c._store && (c._store.validated = !0);
        else if (c) {
          var Q = b(c);
          if (typeof Q == "function" && Q !== c.entries)
            for (var ae = Q.call(c), H; !(H = ae.next()).done; )
              Zr(H.value) && Wt(H.value, v);
        }
      }
    }
    function Oo(c) {
      {
        var v = c.type;
        if (v == null || typeof v == "string")
          return;
        var w;
        if (typeof v == "function")
          w = v.propTypes;
        else if (typeof v == "object" && (v.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        v.$$typeof === m))
          w = v.propTypes;
        else
          return;
        if (w) {
          var j = W(v);
          Gr(w, c.props, "prop", j, c);
        } else if (v.PropTypes !== void 0 && !Jr) {
          Jr = !0;
          var Q = W(v);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Q || "Unknown");
        }
        typeof v.getDefaultProps == "function" && !v.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ro(c) {
      {
        for (var v = Object.keys(c.props), w = 0; w < v.length; w++) {
          var j = v[w];
          if (j !== "children" && j !== "key") {
            He(c), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", j), He(null);
            break;
          }
        }
        c.ref !== null && (He(c), C("Invalid attribute `ref` supplied to `React.Fragment`."), He(null));
      }
    }
    var zt = {};
    function qt(c, v, w, j, Q, ae) {
      {
        var H = T(c);
        if (!H) {
          var K = "";
          (c === void 0 || typeof c == "object" && c !== null && Object.keys(c).length === 0) && (K += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var xe = xo();
          xe ? K += xe : K += Ft();
          var pe;
          c === null ? pe = "null" : Hr(c) ? pe = "array" : c !== void 0 && c.$$typeof === r ? (pe = "<" + (W(c.type) || "Unknown") + " />", K = " Did you accidentally export a JSX literal instead of a component?") : pe = typeof c, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", pe, K);
        }
        var he = So(c, v, w, Q, ae);
        if (he == null)
          return he;
        if (H) {
          var $e = v.children;
          if ($e !== void 0)
            if (j)
              if (Hr($e)) {
                for (var Xe = 0; Xe < $e.length; Xe++)
                  Yt($e[Xe], c);
                Object.freeze && Object.freeze($e);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Yt($e, c);
        }
        if (me.call(v, "key")) {
          var Ve = W(c), Re = Object.keys(v).filter(function(ko) {
            return ko !== "key";
          }), Qr = Re.length > 0 ? "{key: someKey, " + Re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!zt[Ve + Qr]) {
            var Ao = Re.length > 0 ? "{" + Re.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Qr, Ve, Ao, Ve), zt[Ve + Qr] = !0;
          }
        }
        return c === t ? Ro(he) : Oo(he), he;
      }
    }
    function wo(c, v, w) {
      return qt(c, v, w, !0);
    }
    function Po(c, v, w) {
      return qt(c, v, w, !1);
    }
    var Co = Po, $o = wo;
    fr.Fragment = t, fr.jsx = Co, fr.jsxs = $o;
  })()), fr;
}
var yn;
function Bi() {
  return yn || (yn = 1, process.env.NODE_ENV === "production" ? Or.exports = qi() : Or.exports = Ui()), Or.exports;
}
var ir = Bi();
function Vi(e, r) {
  const n = qn({
    key: "css",
    prepend: e
  });
  if (r) {
    const t = n.insert;
    n.insert = (...o) => (o[1].styles.match(/^@layer\s+[^{]*$/) || (o[1].styles = `@layer mui {${o[1].styles}}`), t(...o));
  }
  return n;
}
const ct = /* @__PURE__ */ new Map();
function Jn(e) {
  const {
    injectFirst: r,
    enableCssLayer: n,
    children: t
  } = e, o = ie.useMemo(() => {
    const i = `${r}-${n}`;
    if (typeof document == "object" && ct.has(i))
      return ct.get(i);
    const s = Vi(r, n);
    return ct.set(i, s), s;
  }, [r, n]);
  return r || n ? /* @__PURE__ */ ir.jsx(xi, {
    value: o,
    children: t
  }) : t;
}
process.env.NODE_ENV !== "production" && (Jn.propTypes = {
  /**
   * Your component tree.
   */
  children: L.node,
  /**
   * If true, MUI styles are wrapped in CSS `@layer mui` rule.
   * It helps to override MUI styles when using CSS Modules, Tailwind CSS, plain CSS, or any other styling solution.
   */
  enableCssLayer: L.bool,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: L.bool
});
function Gi(e) {
  return e == null || Object.keys(e).length === 0;
}
function Zn(e) {
  const {
    styles: r,
    defaultTheme: n = {}
  } = e, t = typeof r == "function" ? (o) => r(Gi(o) ? n : o) : r;
  return /* @__PURE__ */ ir.jsx(Pi, {
    styles: t
  });
}
process.env.NODE_ENV !== "production" && (Zn.propTypes = {
  defaultTheme: L.object,
  styles: L.oneOfType([L.array, L.string, L.object, L.func])
});
function Ki(e, r) {
  const n = ht(e, r);
  return process.env.NODE_ENV !== "production" ? (...t) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return t.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : t.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), n(...t);
  } : n;
}
const Hi = (e, r) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = r(e.__emotion_styles));
}, mn = [];
function Xi(e) {
  return mn[0] = e, vr(mn);
}
const Ji = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: Zn,
  StyledEngineProvider: Jn,
  ThemeContext: Dr,
  css: Hn,
  default: Ki,
  internal_processStyles: Hi,
  internal_serializeStyles: Xi,
  keyframes: Ci
}, Symbol.toStringTag, { value: "Module" }));
function ze(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const r = Object.getPrototypeOf(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Qn(e) {
  if (/* @__PURE__ */ ie.isValidElement(e) || !ze(e))
    return e;
  const r = {};
  return Object.keys(e).forEach((n) => {
    r[n] = Qn(e[n]);
  }), r;
}
function je(e, r, n = {
  clone: !0
}) {
  const t = n.clone ? te({}, e) : e;
  return ze(e) && ze(r) && Object.keys(r).forEach((o) => {
    /* @__PURE__ */ ie.isValidElement(r[o]) ? t[o] = r[o] : ze(r[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && ze(e[o]) ? t[o] = je(e[o], r[o], n) : n.clone ? t[o] = ze(r[o]) ? Qn(r[o]) : r[o] : t[o] = r[o];
  }), t;
}
const Zi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: je,
  isPlainObject: ze
}, Symbol.toStringTag, { value: "Module" })), Qi = ["values", "unit", "step"], ea = (e) => {
  const r = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return r.sort((n, t) => n.val - t.val), r.reduce((n, t) => te({}, n, {
    [t.key]: t.val
  }), {});
};
function eo(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: r = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: t = 5
  } = e, o = qe(e, Qi), i = ea(r), s = Object.keys(i);
  function u(h) {
    return `@media (min-width:${typeof r[h] == "number" ? r[h] : h}${n})`;
  }
  function l(h) {
    return `@media (max-width:${(typeof r[h] == "number" ? r[h] : h) - t / 100}${n})`;
  }
  function d(h, x) {
    const g = s.indexOf(x);
    return `@media (min-width:${typeof r[h] == "number" ? r[h] : h}${n}) and (max-width:${(g !== -1 && typeof r[s[g]] == "number" ? r[s[g]] : x) - t / 100}${n})`;
  }
  function y(h) {
    return s.indexOf(h) + 1 < s.length ? d(h, s[s.indexOf(h) + 1]) : u(h);
  }
  function m(h) {
    const x = s.indexOf(h);
    return x === 0 ? u(s[1]) : x === s.length - 1 ? l(s[x]) : d(h, s[s.indexOf(h) + 1]).replace("@media", "@media not all and");
  }
  return te({
    keys: s,
    values: i,
    up: u,
    down: l,
    between: d,
    only: y,
    not: m,
    unit: n
  }, o);
}
const ra = {
  borderRadius: 4
}, Be = process.env.NODE_ENV !== "production" ? L.oneOfType([L.number, L.string, L.object, L.array]) : {};
function lr(e, r) {
  return r ? je(e, r, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Ct = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, hn = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Ct[e]}px)`
};
function Ye(e, r, n) {
  const t = e.theme || {};
  if (Array.isArray(r)) {
    const i = t.breakpoints || hn;
    return r.reduce((s, u, l) => (s[i.up(i.keys[l])] = n(r[l]), s), {});
  }
  if (typeof r == "object") {
    const i = t.breakpoints || hn;
    return Object.keys(r).reduce((s, u) => {
      if (Object.keys(i.values || Ct).indexOf(u) !== -1) {
        const l = i.up(u);
        s[l] = n(r[u], u);
      } else {
        const l = u;
        s[l] = r[l];
      }
      return s;
    }, {});
  }
  return n(r);
}
function ro(e = {}) {
  var r;
  return ((r = e.keys) == null ? void 0 : r.reduce((t, o) => {
    const i = e.up(o);
    return t[i] = {}, t;
  }, {})) || {};
}
function gt(e, r) {
  return e.reduce((n, t) => {
    const o = n[t];
    return (!o || Object.keys(o).length === 0) && delete n[t], n;
  }, r);
}
function uc(e, ...r) {
  const n = ro(e), t = [n, ...r].reduce((o, i) => je(o, i), {});
  return gt(Object.keys(n), t);
}
function ta(e, r) {
  if (typeof e != "object")
    return {};
  const n = {}, t = Object.keys(r);
  return Array.isArray(e) ? t.forEach((o, i) => {
    i < e.length && (n[o] = !0);
  }) : t.forEach((o) => {
    e[o] != null && (n[o] = !0);
  }), n;
}
function fc({
  values: e,
  breakpoints: r,
  base: n
}) {
  const t = n || ta(e, r), o = Object.keys(t);
  if (o.length === 0)
    return e;
  let i;
  return o.reduce((s, u, l) => (Array.isArray(e) ? (s[u] = e[l] != null ? e[l] : e[i], i = l) : typeof e == "object" ? (s[u] = e[u] != null ? e[u] : e[i], i = u) : s[u] = e, s), {});
}
function Ke(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : pr(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const na = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ke
}, Symbol.toStringTag, { value: "Module" }));
function Fr(e, r, n = !0) {
  if (!r || typeof r != "string")
    return null;
  if (e && e.vars && n) {
    const t = `vars.${r}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (t != null)
      return t;
  }
  return r.split(".").reduce((t, o) => t && t[o] != null ? t[o] : null, e);
}
function Ar(e, r, n, t = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || t : o = Fr(e, n) || t, r && (o = r(o, t, e)), o;
}
function ye(e) {
  const {
    prop: r,
    cssProperty: n = e.prop,
    themeKey: t,
    transform: o
  } = e, i = (s) => {
    if (s[r] == null)
      return null;
    const u = s[r], l = s.theme, d = Fr(l, t) || {};
    return Ye(s, u, (m) => {
      let h = Ar(d, o, m);
      return m === h && typeof m == "string" && (h = Ar(d, o, `${r}${m === "default" ? "" : Ke(m)}`, m)), n === !1 ? h : {
        [n]: h
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [r]: Be
  } : {}, i.filterProps = [r], i;
}
function oa(e) {
  const r = {};
  return (n) => (r[n] === void 0 && (r[n] = e(n)), r[n]);
}
const ia = {
  m: "margin",
  p: "padding"
}, aa = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, gn = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, sa = oa((e) => {
  if (e.length > 2)
    if (gn[e])
      e = gn[e];
    else
      return [e];
  const [r, n] = e.split(""), t = ia[r], o = aa[n] || "";
  return Array.isArray(o) ? o.map((i) => t + i) : [t + o];
}), Lr = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Wr = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], ca = [...Lr, ...Wr];
function br(e, r, n, t) {
  var o;
  const i = (o = Fr(e, r, !1)) != null ? o : n;
  return typeof i == "number" ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && typeof s != "number" && console.error(`MUI: Expected ${t} argument to be a number or a string, got ${s}.`), i * s) : Array.isArray(i) ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && (Number.isInteger(s) ? s > i.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${s} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${r}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${r}\` as a number.`].join(`
`))), i[s]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${r}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function to(e) {
  return br(e, "spacing", 8, "spacing");
}
function Er(e, r) {
  if (typeof r == "string" || r == null)
    return r;
  const n = Math.abs(r), t = e(n);
  return r >= 0 ? t : typeof t == "number" ? -t : `-${t}`;
}
function ua(e, r) {
  return (n) => e.reduce((t, o) => (t[o] = Er(r, n), t), {});
}
function fa(e, r, n, t) {
  if (r.indexOf(n) === -1)
    return null;
  const o = sa(n), i = ua(o, t), s = e[n];
  return Ye(e, s, i);
}
function no(e, r) {
  const n = to(e.theme);
  return Object.keys(e).map((t) => fa(e, r, t, n)).reduce(lr, {});
}
function le(e) {
  return no(e, Lr);
}
le.propTypes = process.env.NODE_ENV !== "production" ? Lr.reduce((e, r) => (e[r] = Be, e), {}) : {};
le.filterProps = Lr;
function de(e) {
  return no(e, Wr);
}
de.propTypes = process.env.NODE_ENV !== "production" ? Wr.reduce((e, r) => (e[r] = Be, e), {}) : {};
de.filterProps = Wr;
process.env.NODE_ENV !== "production" && ca.reduce((e, r) => (e[r] = Be, e), {});
function la(e = 8) {
  if (e.mui)
    return e;
  const r = to({
    spacing: e
  }), n = (...t) => (process.env.NODE_ENV !== "production" && (t.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${t.length}`)), (t.length === 0 ? [1] : t).map((i) => {
    const s = r(i);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return n.mui = !0, n;
}
function Yr(...e) {
  const r = e.reduce((t, o) => (o.filterProps.forEach((i) => {
    t[i] = o;
  }), t), {}), n = (t) => Object.keys(t).reduce((o, i) => r[i] ? lr(o, r[i](t)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((t, o) => Object.assign(t, o.propTypes), {}) : {}, n.filterProps = e.reduce((t, o) => t.concat(o.filterProps), []), n;
}
function Ae(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function ke(e, r) {
  return ye({
    prop: e,
    themeKey: "borders",
    transform: r
  });
}
const da = ke("border", Ae), pa = ke("borderTop", Ae), ya = ke("borderRight", Ae), ma = ke("borderBottom", Ae), ha = ke("borderLeft", Ae), ga = ke("borderColor"), va = ke("borderTopColor"), ba = ke("borderRightColor"), Ea = ke("borderBottomColor"), _a = ke("borderLeftColor"), Sa = ke("outline", Ae), xa = ke("outlineColor"), zr = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const r = br(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (t) => ({
      borderRadius: Er(r, t)
    });
    return Ye(e, e.borderRadius, n);
  }
  return null;
};
zr.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Be
} : {};
zr.filterProps = ["borderRadius"];
Yr(da, pa, ya, ma, ha, ga, va, ba, Ea, _a, zr, Sa, xa);
const qr = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const r = br(e.theme, "spacing", 8, "gap"), n = (t) => ({
      gap: Er(r, t)
    });
    return Ye(e, e.gap, n);
  }
  return null;
};
qr.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Be
} : {};
qr.filterProps = ["gap"];
const Ur = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const r = br(e.theme, "spacing", 8, "columnGap"), n = (t) => ({
      columnGap: Er(r, t)
    });
    return Ye(e, e.columnGap, n);
  }
  return null;
};
Ur.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Be
} : {};
Ur.filterProps = ["columnGap"];
const Br = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const r = br(e.theme, "spacing", 8, "rowGap"), n = (t) => ({
      rowGap: Er(r, t)
    });
    return Ye(e, e.rowGap, n);
  }
  return null;
};
Br.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Be
} : {};
Br.filterProps = ["rowGap"];
const Ta = ye({
  prop: "gridColumn"
}), Oa = ye({
  prop: "gridRow"
}), Ra = ye({
  prop: "gridAutoFlow"
}), wa = ye({
  prop: "gridAutoColumns"
}), Pa = ye({
  prop: "gridAutoRows"
}), Ca = ye({
  prop: "gridTemplateColumns"
}), $a = ye({
  prop: "gridTemplateRows"
}), Aa = ye({
  prop: "gridTemplateAreas"
}), ka = ye({
  prop: "gridArea"
});
Yr(qr, Ur, Br, Ta, Oa, Ra, wa, Pa, Ca, $a, Aa, ka);
function nr(e, r) {
  return r === "grey" ? r : e;
}
const Ia = ye({
  prop: "color",
  themeKey: "palette",
  transform: nr
}), ja = ye({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: nr
}), Ma = ye({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: nr
});
Yr(Ia, ja, Ma);
function Pe(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Na = ye({
  prop: "width",
  transform: Pe
}), $t = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const r = (n) => {
      var t, o;
      const i = ((t = e.theme) == null || (t = t.breakpoints) == null || (t = t.values) == null ? void 0 : t[n]) || Ct[n];
      return i ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${i}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: i
      } : {
        maxWidth: Pe(n)
      };
    };
    return Ye(e, e.maxWidth, r);
  }
  return null;
};
$t.filterProps = ["maxWidth"];
const Da = ye({
  prop: "minWidth",
  transform: Pe
}), Fa = ye({
  prop: "height",
  transform: Pe
}), La = ye({
  prop: "maxHeight",
  transform: Pe
}), Wa = ye({
  prop: "minHeight",
  transform: Pe
});
ye({
  prop: "size",
  cssProperty: "width",
  transform: Pe
});
ye({
  prop: "size",
  cssProperty: "height",
  transform: Pe
});
const Ya = ye({
  prop: "boxSizing"
});
Yr(Na, $t, Da, Fa, La, Wa, Ya);
const _r = {
  // borders
  border: {
    themeKey: "borders",
    transform: Ae
  },
  borderTop: {
    themeKey: "borders",
    transform: Ae
  },
  borderRight: {
    themeKey: "borders",
    transform: Ae
  },
  borderBottom: {
    themeKey: "borders",
    transform: Ae
  },
  borderLeft: {
    themeKey: "borders",
    transform: Ae
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Ae
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: zr
  },
  // palette
  color: {
    themeKey: "palette",
    transform: nr
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: nr
  },
  backgroundColor: {
    themeKey: "palette",
    transform: nr
  },
  // spacing
  p: {
    style: de
  },
  pt: {
    style: de
  },
  pr: {
    style: de
  },
  pb: {
    style: de
  },
  pl: {
    style: de
  },
  px: {
    style: de
  },
  py: {
    style: de
  },
  padding: {
    style: de
  },
  paddingTop: {
    style: de
  },
  paddingRight: {
    style: de
  },
  paddingBottom: {
    style: de
  },
  paddingLeft: {
    style: de
  },
  paddingX: {
    style: de
  },
  paddingY: {
    style: de
  },
  paddingInline: {
    style: de
  },
  paddingInlineStart: {
    style: de
  },
  paddingInlineEnd: {
    style: de
  },
  paddingBlock: {
    style: de
  },
  paddingBlockStart: {
    style: de
  },
  paddingBlockEnd: {
    style: de
  },
  m: {
    style: le
  },
  mt: {
    style: le
  },
  mr: {
    style: le
  },
  mb: {
    style: le
  },
  ml: {
    style: le
  },
  mx: {
    style: le
  },
  my: {
    style: le
  },
  margin: {
    style: le
  },
  marginTop: {
    style: le
  },
  marginRight: {
    style: le
  },
  marginBottom: {
    style: le
  },
  marginLeft: {
    style: le
  },
  marginX: {
    style: le
  },
  marginY: {
    style: le
  },
  marginInline: {
    style: le
  },
  marginInlineStart: {
    style: le
  },
  marginInlineEnd: {
    style: le
  },
  marginBlock: {
    style: le
  },
  marginBlockStart: {
    style: le
  },
  marginBlockEnd: {
    style: le
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: qr
  },
  rowGap: {
    style: Br
  },
  columnGap: {
    style: Ur
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Pe
  },
  maxWidth: {
    style: $t
  },
  minWidth: {
    transform: Pe
  },
  height: {
    transform: Pe
  },
  maxHeight: {
    transform: Pe
  },
  minHeight: {
    transform: Pe
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function za(...e) {
  const r = e.reduce((t, o) => t.concat(Object.keys(o)), []), n = new Set(r);
  return e.every((t) => n.size === Object.keys(t).length);
}
function qa(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function oo() {
  function e(n, t, o, i) {
    const s = {
      [n]: t,
      theme: o
    }, u = i[n];
    if (!u)
      return {
        [n]: t
      };
    const {
      cssProperty: l = n,
      themeKey: d,
      transform: y,
      style: m
    } = u;
    if (t == null)
      return null;
    if (d === "typography" && t === "inherit")
      return {
        [n]: t
      };
    const h = Fr(o, d) || {};
    return m ? m(s) : Ye(s, t, (g) => {
      let a = Ar(h, y, g);
      return g === a && typeof g == "string" && (a = Ar(h, y, `${n}${g === "default" ? "" : Ke(g)}`, g)), l === !1 ? a : {
        [l]: a
      };
    });
  }
  function r(n) {
    var t;
    const {
      sx: o,
      theme: i = {},
      nested: s
    } = n || {};
    if (!o)
      return null;
    const u = (t = i.unstable_sxConfig) != null ? t : _r;
    function l(d) {
      let y = d;
      if (typeof d == "function")
        y = d(i);
      else if (typeof d != "object")
        return d;
      if (!y)
        return null;
      const m = ro(i.breakpoints), h = Object.keys(m);
      let x = m;
      return Object.keys(y).forEach((g) => {
        const a = qa(y[g], i);
        if (a != null)
          if (typeof a == "object")
            if (u[g])
              x = lr(x, e(g, a, i, u));
            else {
              const b = Ye({
                theme: i
              }, a, (R) => ({
                [g]: R
              }));
              za(b, a) ? x[g] = r({
                sx: a,
                theme: i,
                nested: !0
              }) : x = lr(x, b);
            }
          else
            x = lr(x, e(g, a, i, u));
      }), !s && i.modularCssLayers ? {
        "@layer sx": gt(h, x)
      } : gt(h, x);
    }
    return Array.isArray(o) ? o.map(l) : l(o);
  }
  return r;
}
const Vr = oo();
Vr.filterProps = ["sx"];
function io(e, r) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: r
  } : n.palette.mode === e ? r : {};
}
const Ua = ["breakpoints", "palette", "spacing", "shape"];
function ao(e = {}, ...r) {
  const {
    breakpoints: n = {},
    palette: t = {},
    spacing: o,
    shape: i = {}
  } = e, s = qe(e, Ua), u = eo(n), l = la(o);
  let d = je({
    breakpoints: u,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: te({
      mode: "light"
    }, t),
    spacing: l,
    shape: te({}, ra, i)
  }, s);
  return d.applyStyles = io, d = r.reduce((y, m) => je(y, m), d), d.unstable_sxConfig = te({}, _r, s?.unstable_sxConfig), d.unstable_sx = function(m) {
    return Vr({
      sx: m,
      theme: this
    });
  }, d;
}
const Ba = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ao,
  private_createBreakpoints: eo,
  unstable_applyStyles: io
}, Symbol.toStringTag, { value: "Module" })), Va = ["sx"], Ga = (e) => {
  var r, n;
  const t = {
    systemProps: {},
    otherProps: {}
  }, o = (r = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? r : _r;
  return Object.keys(e).forEach((i) => {
    o[i] ? t.systemProps[i] = e[i] : t.otherProps[i] = e[i];
  }), t;
};
function Ka(e) {
  const {
    sx: r
  } = e, n = qe(e, Va), {
    systemProps: t,
    otherProps: o
  } = Ga(n);
  let i;
  return Array.isArray(r) ? i = [t, ...r] : typeof r == "function" ? i = (...s) => {
    const u = r(...s);
    return ze(u) ? te({}, t, u) : t;
  } : i = te({}, t, r), te({}, o, {
    sx: i
  });
}
const Ha = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vr,
  extendSxProp: Ka,
  unstable_createStyleFunctionSx: oo,
  unstable_defaultSxConfig: _r
}, Symbol.toStringTag, { value: "Module" })), vn = (e) => e, Xa = () => {
  let e = vn;
  return {
    configure(r) {
      e = r;
    },
    generate(r) {
      return e(r);
    },
    reset() {
      e = vn;
    }
  };
}, Ja = Xa();
function so(e) {
  var r, n, t = "";
  if (typeof e == "string" || typeof e == "number") t += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (r = 0; r < o; r++) e[r] && (n = so(e[r])) && (t && (t += " "), t += n);
  } else for (n in e) e[n] && (t && (t += " "), t += n);
  return t;
}
function Za() {
  for (var e, r, n = 0, t = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (r = so(e)) && (t && (t += " "), t += r);
  return t;
}
const Qa = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function At(e, r, n = "Mui") {
  const t = Qa[r];
  return t ? `${n}-${t}` : `${Ja.generate(e)}-${r}`;
}
function es(e, r, n = "Mui") {
  const t = {};
  return r.forEach((o) => {
    t[o] = At(e, o, n);
  }), t;
}
var Rr = { exports: {} }, ne = {};
var bn;
function rs() {
  if (bn) return ne;
  bn = 1;
  var e = /* @__PURE__ */ Symbol.for("react.transitional.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), t = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), i = /* @__PURE__ */ Symbol.for("react.consumer"), s = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), l = /* @__PURE__ */ Symbol.for("react.suspense"), d = /* @__PURE__ */ Symbol.for("react.suspense_list"), y = /* @__PURE__ */ Symbol.for("react.memo"), m = /* @__PURE__ */ Symbol.for("react.lazy"), h = /* @__PURE__ */ Symbol.for("react.view_transition"), x = /* @__PURE__ */ Symbol.for("react.client.reference");
  function g(a) {
    if (typeof a == "object" && a !== null) {
      var b = a.$$typeof;
      switch (b) {
        case e:
          switch (a = a.type, a) {
            case n:
            case o:
            case t:
            case l:
            case d:
            case h:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case s:
                case u:
                case m:
                case y:
                  return a;
                case i:
                  return a;
                default:
                  return b;
              }
          }
        case r:
          return b;
      }
    }
  }
  return ne.ContextConsumer = i, ne.ContextProvider = s, ne.Element = e, ne.ForwardRef = u, ne.Fragment = n, ne.Lazy = m, ne.Memo = y, ne.Portal = r, ne.Profiler = o, ne.StrictMode = t, ne.Suspense = l, ne.SuspenseList = d, ne.isContextConsumer = function(a) {
    return g(a) === i;
  }, ne.isContextProvider = function(a) {
    return g(a) === s;
  }, ne.isElement = function(a) {
    return typeof a == "object" && a !== null && a.$$typeof === e;
  }, ne.isForwardRef = function(a) {
    return g(a) === u;
  }, ne.isFragment = function(a) {
    return g(a) === n;
  }, ne.isLazy = function(a) {
    return g(a) === m;
  }, ne.isMemo = function(a) {
    return g(a) === y;
  }, ne.isPortal = function(a) {
    return g(a) === r;
  }, ne.isProfiler = function(a) {
    return g(a) === o;
  }, ne.isStrictMode = function(a) {
    return g(a) === t;
  }, ne.isSuspense = function(a) {
    return g(a) === l;
  }, ne.isSuspenseList = function(a) {
    return g(a) === d;
  }, ne.isValidElementType = function(a) {
    return typeof a == "string" || typeof a == "function" || a === n || a === o || a === t || a === l || a === d || typeof a == "object" && a !== null && (a.$$typeof === m || a.$$typeof === y || a.$$typeof === s || a.$$typeof === i || a.$$typeof === u || a.$$typeof === x || a.getModuleId !== void 0);
  }, ne.typeOf = g, ne;
}
var oe = {};
var En;
function ts() {
  return En || (En = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(a) {
      if (typeof a == "object" && a !== null) {
        var b = a.$$typeof;
        switch (b) {
          case r:
            switch (a = a.type, a) {
              case t:
              case i:
              case o:
              case d:
              case y:
              case x:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case u:
                  case l:
                  case h:
                  case m:
                    return a;
                  case s:
                    return a;
                  default:
                    return b;
                }
            }
          case n:
            return b;
        }
      }
    }
    var r = /* @__PURE__ */ Symbol.for("react.transitional.element"), n = /* @__PURE__ */ Symbol.for("react.portal"), t = /* @__PURE__ */ Symbol.for("react.fragment"), o = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.consumer"), u = /* @__PURE__ */ Symbol.for("react.context"), l = /* @__PURE__ */ Symbol.for("react.forward_ref"), d = /* @__PURE__ */ Symbol.for("react.suspense"), y = /* @__PURE__ */ Symbol.for("react.suspense_list"), m = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), x = /* @__PURE__ */ Symbol.for("react.view_transition"), g = /* @__PURE__ */ Symbol.for("react.client.reference");
    oe.ContextConsumer = s, oe.ContextProvider = u, oe.Element = r, oe.ForwardRef = l, oe.Fragment = t, oe.Lazy = h, oe.Memo = m, oe.Portal = n, oe.Profiler = i, oe.StrictMode = o, oe.Suspense = d, oe.SuspenseList = y, oe.isContextConsumer = function(a) {
      return e(a) === s;
    }, oe.isContextProvider = function(a) {
      return e(a) === u;
    }, oe.isElement = function(a) {
      return typeof a == "object" && a !== null && a.$$typeof === r;
    }, oe.isForwardRef = function(a) {
      return e(a) === l;
    }, oe.isFragment = function(a) {
      return e(a) === t;
    }, oe.isLazy = function(a) {
      return e(a) === h;
    }, oe.isMemo = function(a) {
      return e(a) === m;
    }, oe.isPortal = function(a) {
      return e(a) === n;
    }, oe.isProfiler = function(a) {
      return e(a) === i;
    }, oe.isStrictMode = function(a) {
      return e(a) === o;
    }, oe.isSuspense = function(a) {
      return e(a) === d;
    }, oe.isSuspenseList = function(a) {
      return e(a) === y;
    }, oe.isValidElementType = function(a) {
      return typeof a == "string" || typeof a == "function" || a === t || a === i || a === o || a === d || a === y || typeof a == "object" && a !== null && (a.$$typeof === h || a.$$typeof === m || a.$$typeof === u || a.$$typeof === s || a.$$typeof === l || a.$$typeof === g || a.getModuleId !== void 0);
    }, oe.typeOf = e;
  })()), oe;
}
var _n;
function ns() {
  return _n || (_n = 1, process.env.NODE_ENV === "production" ? Rr.exports = /* @__PURE__ */ rs() : Rr.exports = /* @__PURE__ */ ts()), Rr.exports;
}
var Sn = /* @__PURE__ */ ns();
const os = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function co(e) {
  const r = `${e}`.match(os);
  return r && r[1] || "";
}
function uo(e, r = "") {
  return e.displayName || e.name || co(e) || r;
}
function xn(e, r, n) {
  const t = uo(r);
  return e.displayName || (t !== "" ? `${n}(${t})` : n);
}
function is(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return uo(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case Sn.ForwardRef:
          return xn(e, e.render, "ForwardRef");
        case Sn.Memo:
          return xn(e, e.type, "memo");
        default:
          return;
      }
  }
}
const as = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: is,
  getFunctionName: co
}, Symbol.toStringTag, { value: "Module" }));
function vt(e, r) {
  const n = te({}, r);
  return Object.keys(e).forEach((t) => {
    if (t.toString().match(/^(components|slots)$/))
      n[t] = te({}, e[t], n[t]);
    else if (t.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[t] || {}, i = r[t];
      n[t] = {}, !i || !Object.keys(i) ? n[t] = o : !o || !Object.keys(o) ? n[t] = i : (n[t] = te({}, i), Object.keys(o).forEach((s) => {
        n[t][s] = vt(o[s], i[s]);
      }));
    } else n[t] === void 0 && (n[t] = e[t]);
  }), n;
}
function ss(e, r = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(r, Math.min(e, n));
}
const cs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ss
}, Symbol.toStringTag, { value: "Module" }));
function us(e, r, n = void 0) {
  const t = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      t[o] = e[o].reduce((i, s) => {
        if (s) {
          const u = r(s);
          u !== "" && i.push(u), n && n[s] && i.push(n[s]);
        }
        return i;
      }, []).join(" ");
    }
  ), t;
}
const fo = /* @__PURE__ */ ie.createContext(void 0);
function fs({
  value: e,
  children: r
}) {
  return /* @__PURE__ */ ir.jsx(fo.Provider, {
    value: e,
    children: r
  });
}
process.env.NODE_ENV !== "production" && (fs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: L.node,
  /**
   * @ignore
   */
  value: L.object
});
function ls(e) {
  const {
    theme: r,
    name: n,
    props: t
  } = e;
  if (!r || !r.components || !r.components[n])
    return t;
  const o = r.components[n];
  return o.defaultProps ? vt(o.defaultProps, t) : !o.styleOverrides && !o.variants ? vt(o, t) : t;
}
function ds({
  props: e,
  name: r
}) {
  const n = ie.useContext(fo);
  return ls({
    props: e,
    name: r,
    theme: {
      components: n
    }
  });
}
function ps(e, r) {
  return te({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, r);
}
var fe = {}, ut = { exports: {} }, Tn;
function lo() {
  return Tn || (Tn = 1, (function(e) {
    function r(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(ut)), ut.exports;
}
const ys = /* @__PURE__ */ Ue(No), ms = /* @__PURE__ */ Ue(cs);
var On;
function hs() {
  if (On) return fe;
  On = 1;
  var e = lo();
  Object.defineProperty(fe, "__esModule", {
    value: !0
  }), fe.alpha = g, fe.blend = q, fe.colorChannel = void 0, fe.darken = b, fe.decomposeColor = s, fe.emphasize = M, fe.getContrastRatio = x, fe.getLuminance = h, fe.hexToRgb = o, fe.hslToRgb = m, fe.lighten = C, fe.private_safeAlpha = a, fe.private_safeColorChannel = void 0, fe.private_safeDarken = R, fe.private_safeEmphasize = S, fe.private_safeLighten = k, fe.recomposeColor = d, fe.rgbToHex = y;
  var r = e(ys), n = e(ms);
  function t(f, p = 0, E = 1) {
    return process.env.NODE_ENV !== "production" && (f < p || f > E) && console.error(`MUI: The value provided ${f} is out of range [${p}, ${E}].`), (0, n.default)(f, p, E);
  }
  function o(f) {
    f = f.slice(1);
    const p = new RegExp(`.{1,${f.length >= 6 ? 2 : 1}}`, "g");
    let E = f.match(p);
    return E && E[0].length === 1 && (E = E.map((T) => T + T)), E ? `rgb${E.length === 4 ? "a" : ""}(${E.map((T, A) => A < 3 ? parseInt(T, 16) : Math.round(parseInt(T, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
  }
  function i(f) {
    const p = f.toString(16);
    return p.length === 1 ? `0${p}` : p;
  }
  function s(f) {
    if (f.type)
      return f;
    if (f.charAt(0) === "#")
      return s(o(f));
    const p = f.indexOf("("), E = f.substring(0, p);
    if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(E) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${f}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, r.default)(9, f));
    let T = f.substring(p + 1, f.length - 1), A;
    if (E === "color") {
      if (T = T.split(" "), A = T.shift(), T.length === 4 && T[3].charAt(0) === "/" && (T[3] = T[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(A) === -1)
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${A}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, r.default)(10, A));
    } else
      T = T.split(",");
    return T = T.map((se) => parseFloat(se)), {
      type: E,
      values: T,
      colorSpace: A
    };
  }
  const u = (f) => {
    const p = s(f);
    return p.values.slice(0, 3).map((E, T) => p.type.indexOf("hsl") !== -1 && T !== 0 ? `${E}%` : E).join(" ");
  };
  fe.colorChannel = u;
  const l = (f, p) => {
    try {
      return u(f);
    } catch {
      return p && process.env.NODE_ENV !== "production" && console.warn(p), f;
    }
  };
  fe.private_safeColorChannel = l;
  function d(f) {
    const {
      type: p,
      colorSpace: E
    } = f;
    let {
      values: T
    } = f;
    return p.indexOf("rgb") !== -1 ? T = T.map((A, se) => se < 3 ? parseInt(A, 10) : A) : p.indexOf("hsl") !== -1 && (T[1] = `${T[1]}%`, T[2] = `${T[2]}%`), p.indexOf("color") !== -1 ? T = `${E} ${T.join(" ")}` : T = `${T.join(", ")}`, `${p}(${T})`;
  }
  function y(f) {
    if (f.indexOf("#") === 0)
      return f;
    const {
      values: p
    } = s(f);
    return `#${p.map((E, T) => i(T === 3 ? Math.round(255 * E) : E)).join("")}`;
  }
  function m(f) {
    f = s(f);
    const {
      values: p
    } = f, E = p[0], T = p[1] / 100, A = p[2] / 100, se = T * Math.min(A, 1 - A), W = (V, X = (V + E / 30) % 12) => A - se * Math.max(Math.min(X - 3, 9 - X, 1), -1);
    let U = "rgb";
    const ve = [Math.round(W(0) * 255), Math.round(W(8) * 255), Math.round(W(4) * 255)];
    return f.type === "hsla" && (U += "a", ve.push(p[3])), d({
      type: U,
      values: ve
    });
  }
  function h(f) {
    f = s(f);
    let p = f.type === "hsl" || f.type === "hsla" ? s(m(f)).values : f.values;
    return p = p.map((E) => (f.type !== "color" && (E /= 255), E <= 0.03928 ? E / 12.92 : ((E + 0.055) / 1.055) ** 2.4)), Number((0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]).toFixed(3));
  }
  function x(f, p) {
    const E = h(f), T = h(p);
    return (Math.max(E, T) + 0.05) / (Math.min(E, T) + 0.05);
  }
  function g(f, p) {
    return f = s(f), p = t(p), (f.type === "rgb" || f.type === "hsl") && (f.type += "a"), f.type === "color" ? f.values[3] = `/${p}` : f.values[3] = p, d(f);
  }
  function a(f, p, E) {
    try {
      return g(f, p);
    } catch {
      return E && process.env.NODE_ENV !== "production" && console.warn(E), f;
    }
  }
  function b(f, p) {
    if (f = s(f), p = t(p), f.type.indexOf("hsl") !== -1)
      f.values[2] *= 1 - p;
    else if (f.type.indexOf("rgb") !== -1 || f.type.indexOf("color") !== -1)
      for (let E = 0; E < 3; E += 1)
        f.values[E] *= 1 - p;
    return d(f);
  }
  function R(f, p, E) {
    try {
      return b(f, p);
    } catch {
      return E && process.env.NODE_ENV !== "production" && console.warn(E), f;
    }
  }
  function C(f, p) {
    if (f = s(f), p = t(p), f.type.indexOf("hsl") !== -1)
      f.values[2] += (100 - f.values[2]) * p;
    else if (f.type.indexOf("rgb") !== -1)
      for (let E = 0; E < 3; E += 1)
        f.values[E] += (255 - f.values[E]) * p;
    else if (f.type.indexOf("color") !== -1)
      for (let E = 0; E < 3; E += 1)
        f.values[E] += (1 - f.values[E]) * p;
    return d(f);
  }
  function k(f, p, E) {
    try {
      return C(f, p);
    } catch {
      return E && process.env.NODE_ENV !== "production" && console.warn(E), f;
    }
  }
  function M(f, p = 0.15) {
    return h(f) > 0.5 ? b(f, p) : C(f, p);
  }
  function S(f, p, E) {
    try {
      return M(f, p);
    } catch {
      return E && process.env.NODE_ENV !== "production" && console.warn(E), f;
    }
  }
  function q(f, p, E, T = 1) {
    const A = (ve, V) => Math.round((ve ** (1 / T) * (1 - E) + V ** (1 / T) * E) ** T), se = s(f), W = s(p), U = [A(se.values[0], W.values[0]), A(se.values[1], W.values[1]), A(se.values[2], W.values[2])];
    return d({
      type: "rgb",
      values: U
    });
  }
  return fe;
}
var kr = /* @__PURE__ */ hs();
const gs = ["mode", "contrastThreshold", "tonalOffset"], Rn = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: dr.white,
    default: dr.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, ft = {
  text: {
    primary: dr.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: dr.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function wn(e, r, n, t) {
  const o = t.light || t, i = t.dark || t * 1.5;
  e[r] || (e.hasOwnProperty(n) ? e[r] = e[n] : r === "light" ? e.light = kr.lighten(e.main, o) : r === "dark" && (e.dark = kr.darken(e.main, i)));
}
function vs(e = "light") {
  return e === "dark" ? {
    main: Qe[200],
    light: Qe[50],
    dark: Qe[400]
  } : {
    main: Qe[700],
    light: Qe[400],
    dark: Qe[800]
  };
}
function bs(e = "light") {
  return e === "dark" ? {
    main: Ze[200],
    light: Ze[50],
    dark: Ze[400]
  } : {
    main: Ze[500],
    light: Ze[300],
    dark: Ze[700]
  };
}
function Es(e = "light") {
  return e === "dark" ? {
    main: Je[500],
    light: Je[300],
    dark: Je[700]
  } : {
    main: Je[700],
    light: Je[400],
    dark: Je[800]
  };
}
function _s(e = "light") {
  return e === "dark" ? {
    main: er[400],
    light: er[300],
    dark: er[700]
  } : {
    main: er[700],
    light: er[500],
    dark: er[900]
  };
}
function Ss(e = "light") {
  return e === "dark" ? {
    main: rr[400],
    light: rr[300],
    dark: rr[700]
  } : {
    main: rr[800],
    light: rr[500],
    dark: rr[900]
  };
}
function xs(e = "light") {
  return e === "dark" ? {
    main: sr[400],
    light: sr[300],
    dark: sr[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: sr[500],
    dark: sr[900]
  };
}
function Ts(e) {
  const {
    mode: r = "light",
    contrastThreshold: n = 3,
    tonalOffset: t = 0.2
  } = e, o = qe(e, gs), i = e.primary || vs(r), s = e.secondary || bs(r), u = e.error || Es(r), l = e.info || _s(r), d = e.success || Ss(r), y = e.warning || xs(r);
  function m(a) {
    const b = kr.getContrastRatio(a, ft.text.primary) >= n ? ft.text.primary : Rn.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const R = kr.getContrastRatio(a, b);
      R < 3 && console.error([`MUI: The contrast ratio of ${R}:1 for ${b} on ${a}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return b;
  }
  const h = ({
    color: a,
    name: b,
    mainShade: R = 500,
    lightShade: C = 300,
    darkShade: k = 700
  }) => {
    if (a = te({}, a), !a.main && a[R] && (a.main = a[R]), !a.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${R}\` property.` : pr(11, b ? ` (${b})` : "", R));
    if (typeof a.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(a.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : pr(12, b ? ` (${b})` : "", JSON.stringify(a.main)));
    return wn(a, "light", C, t), wn(a, "dark", k, t), a.contrastText || (a.contrastText = m(a.main)), a;
  }, x = {
    dark: ft,
    light: Rn
  };
  return process.env.NODE_ENV !== "production" && (x[r] || console.error(`MUI: The palette mode \`${r}\` is not supported.`)), je(te({
    // A collection of common colors.
    common: te({}, dr),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: r,
    // The colors used to represent primary interface elements for a user.
    primary: h({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: h({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: h({
      color: u,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: h({
      color: y,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: h({
      color: l,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: h({
      color: d,
      name: "success"
    }),
    // The grey colors.
    grey: Mo,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: m,
    // Generate a rich color object.
    augmentColor: h,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: t
  }, x[r]), o);
}
const Os = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function Rs(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Pn = {
  textTransform: "uppercase"
}, Cn = '"Roboto", "Helvetica", "Arial", sans-serif';
function ws(e, r) {
  const n = typeof r == "function" ? r(e) : r, {
    fontFamily: t = Cn,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: s = 400,
    fontWeightMedium: u = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: d = 16,
    // Apply the CSS properties to all the variants.
    allVariants: y,
    pxToRem: m
  } = n, h = qe(n, Os);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof d != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const x = o / 14, g = m || ((R) => `${R / d * x}rem`), a = (R, C, k, M, S) => te({
    fontFamily: t,
    fontWeight: R,
    fontSize: g(C),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: k
  }, t === Cn ? {
    letterSpacing: `${Rs(M / C)}em`
  } : {}, S, y), b = {
    h1: a(i, 96, 1.167, -1.5),
    h2: a(i, 60, 1.2, -0.5),
    h3: a(s, 48, 1.167, 0),
    h4: a(s, 34, 1.235, 0.25),
    h5: a(s, 24, 1.334, 0),
    h6: a(u, 20, 1.6, 0.15),
    subtitle1: a(s, 16, 1.75, 0.15),
    subtitle2: a(u, 14, 1.57, 0.1),
    body1: a(s, 16, 1.5, 0.15),
    body2: a(s, 14, 1.43, 0.15),
    button: a(u, 14, 1.75, 0.4, Pn),
    caption: a(s, 12, 1.66, 0.4),
    overline: a(s, 12, 2.66, 1, Pn),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return je(te({
    htmlFontSize: d,
    pxToRem: g,
    fontFamily: t,
    fontSize: o,
    fontWeightLight: i,
    fontWeightRegular: s,
    fontWeightMedium: u,
    fontWeightBold: l
  }, b), h, {
    clone: !1
    // No need to clone deep
  });
}
const Ps = 0.2, Cs = 0.14, $s = 0.12;
function ue(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Ps})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Cs})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${$s})`].join(",");
}
const As = ["none", ue(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ue(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ue(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ue(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ue(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ue(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ue(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ue(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ue(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ue(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ue(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ue(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ue(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ue(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ue(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ue(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ue(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ue(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ue(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ue(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ue(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ue(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ue(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ue(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], ks = ["duration", "easing", "delay"], Is = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, js = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function $n(e) {
  return `${Math.round(e)}ms`;
}
function Ms(e) {
  if (!e)
    return 0;
  const r = e / 36;
  return Math.round((4 + 15 * r ** 0.25 + r / 5) * 10);
}
function Ns(e) {
  const r = te({}, Is, e.easing), n = te({}, js, e.duration);
  return te({
    getAutoHeightDuration: Ms,
    create: (o = ["all"], i = {}) => {
      const {
        duration: s = n.standard,
        easing: u = r.easeInOut,
        delay: l = 0
      } = i, d = qe(i, ks);
      if (process.env.NODE_ENV !== "production") {
        const y = (h) => typeof h == "string", m = (h) => !isNaN(parseFloat(h));
        !y(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !m(s) && !y(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), y(u) || console.error('MUI: Argument "easing" must be a string.'), !m(l) && !y(l) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(d).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(d).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((y) => `${y} ${typeof s == "string" ? s : $n(s)} ${u} ${typeof l == "string" ? l : $n(l)}`).join(",");
    }
  }, e, {
    easing: r,
    duration: n
  });
}
const Ds = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Fs = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Ls(e = {}, ...r) {
  const {
    mixins: n = {},
    palette: t = {},
    transitions: o = {},
    typography: i = {}
  } = e, s = qe(e, Fs);
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateCssVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : pr(18));
  const u = Ts(t), l = ao(e);
  let d = je(l, {
    mixins: ps(l.breakpoints, n),
    palette: u,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: As.slice(),
    typography: ws(u, i),
    transitions: Ns(o),
    zIndex: te({}, Ds)
  });
  if (d = je(d, s), d = r.reduce((y, m) => je(y, m), d), process.env.NODE_ENV !== "production") {
    const y = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], m = (h, x) => {
      let g;
      for (g in h) {
        const a = h[g];
        if (y.indexOf(g) !== -1 && Object.keys(a).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const b = At("", g);
            console.error([`MUI: The \`${x}\` component increases the CSS specificity of the \`${g}\` internal state.`, "You can not override it like this: ", JSON.stringify(h, null, 2), "", `Instead, you need to use the '&.${b}' syntax:`, JSON.stringify({
              root: {
                [`&.${b}`]: a
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          h[g] = {};
        }
      }
    };
    Object.keys(d.components).forEach((h) => {
      const x = d.components[h].styleOverrides;
      x && h.indexOf("Mui") === 0 && m(x, h);
    });
  }
  return d.unstable_sxConfig = te({}, _r, s?.unstable_sxConfig), d.unstable_sx = function(m) {
    return Vr({
      sx: m,
      theme: this
    });
  }, d;
}
const Ws = Ls();
var Ge = {}, lt = { exports: {} }, An;
function Ys() {
  return An || (An = 1, (function(e) {
    function r() {
      return e.exports = r = Object.assign ? Object.assign.bind() : function(n) {
        for (var t = 1; t < arguments.length; t++) {
          var o = arguments[t];
          for (var i in o) ({}).hasOwnProperty.call(o, i) && (n[i] = o[i]);
        }
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r.apply(null, arguments);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(lt)), lt.exports;
}
var dt = { exports: {} }, kn;
function zs() {
  return kn || (kn = 1, (function(e) {
    function r(n, t) {
      if (n == null) return {};
      var o = {};
      for (var i in n) if ({}.hasOwnProperty.call(n, i)) {
        if (t.indexOf(i) !== -1) continue;
        o[i] = n[i];
      }
      return o;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(dt)), dt.exports;
}
const qs = /* @__PURE__ */ Ue(Ji), Us = /* @__PURE__ */ Ue(Zi), Bs = /* @__PURE__ */ Ue(na), Vs = /* @__PURE__ */ Ue(as), Gs = /* @__PURE__ */ Ue(Ba), Ks = /* @__PURE__ */ Ue(Ha);
var In;
function Hs() {
  if (In) return Ge;
  In = 1;
  var e = lo();
  Object.defineProperty(Ge, "__esModule", {
    value: !0
  }), Ge.default = f, Ge.shouldForwardProp = b, Ge.systemDefaultTheme = void 0;
  var r = e(Ys()), n = e(zs()), t = x(qs), o = Us, i = e(Bs), s = e(Vs), u = e(Gs), l = e(Ks);
  const d = ["ownerState"], y = ["variants"], m = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
  function h(p) {
    if (typeof WeakMap != "function") return null;
    var E = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakMap();
    return (h = function(A) {
      return A ? T : E;
    })(p);
  }
  function x(p, E) {
    if (p && p.__esModule) return p;
    if (p === null || typeof p != "object" && typeof p != "function") return { default: p };
    var T = h(E);
    if (T && T.has(p)) return T.get(p);
    var A = { __proto__: null }, se = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var W in p) if (W !== "default" && Object.prototype.hasOwnProperty.call(p, W)) {
      var U = se ? Object.getOwnPropertyDescriptor(p, W) : null;
      U && (U.get || U.set) ? Object.defineProperty(A, W, U) : A[W] = p[W];
    }
    return A.default = p, T && T.set(p, A), A;
  }
  function g(p) {
    return Object.keys(p).length === 0;
  }
  function a(p) {
    return typeof p == "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    p.charCodeAt(0) > 96;
  }
  function b(p) {
    return p !== "ownerState" && p !== "theme" && p !== "sx" && p !== "as";
  }
  function R(p, E) {
    return E && p && typeof p == "object" && p.styles && !p.styles.startsWith("@layer") && (p.styles = `@layer ${E}{${String(p.styles)}}`), p;
  }
  const C = Ge.systemDefaultTheme = (0, u.default)(), k = (p) => p && p.charAt(0).toLowerCase() + p.slice(1);
  function M({
    defaultTheme: p,
    theme: E,
    themeId: T
  }) {
    return g(E) ? p : E[T] || E;
  }
  function S(p) {
    return p ? (E, T) => T[p] : null;
  }
  function q(p, E, T) {
    let {
      ownerState: A
    } = E, se = (0, n.default)(E, d);
    const W = typeof p == "function" ? p((0, r.default)({
      ownerState: A
    }, se)) : p;
    if (Array.isArray(W))
      return W.flatMap((U) => q(U, (0, r.default)({
        ownerState: A
      }, se), T));
    if (W && typeof W == "object" && Array.isArray(W.variants)) {
      const {
        variants: U = []
      } = W;
      let V = (0, n.default)(W, y);
      return U.forEach((X) => {
        let Te = !0;
        if (typeof X.props == "function" ? Te = X.props((0, r.default)({
          ownerState: A
        }, se, A)) : Object.keys(X.props).forEach((_e) => {
          A?.[_e] !== X.props[_e] && se[_e] !== X.props[_e] && (Te = !1);
        }), Te) {
          Array.isArray(V) || (V = [V]);
          const _e = typeof X.style == "function" ? X.style((0, r.default)({
            ownerState: A
          }, se, A)) : X.style;
          V.push(T ? R((0, t.internal_serializeStyles)(_e), T) : _e);
        }
      }), V;
    }
    return T ? R((0, t.internal_serializeStyles)(W), T) : W;
  }
  function f(p = {}) {
    const {
      themeId: E,
      defaultTheme: T = C,
      rootShouldForwardProp: A = b,
      slotShouldForwardProp: se = b
    } = p, W = (U) => (0, l.default)((0, r.default)({}, U, {
      theme: M((0, r.default)({}, U, {
        defaultTheme: T,
        themeId: E
      }))
    }));
    return W.__mui_systemSx = !0, (U, ve = {}) => {
      (0, t.internal_processStyles)(U, ($) => $.filter((ce) => !(ce != null && ce.__mui_systemSx)));
      const {
        name: V,
        slot: X,
        skipVariantsResolver: Te,
        skipSx: _e,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver: _ = S(k(X))
      } = ve, P = (0, n.default)(ve, m), Y = V && V.startsWith("Mui") || X ? "components" : "custom", F = Te !== void 0 ? Te : (
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        X && X !== "Root" && X !== "root" || !1
      ), N = _e || !1;
      let B;
      process.env.NODE_ENV !== "production" && V && (B = `${V}-${k(X || "Root")}`);
      let I = b;
      X === "Root" || X === "root" ? I = A : X ? I = se : a(U) && (I = void 0);
      const D = (0, t.default)(U, (0, r.default)({
        shouldForwardProp: I,
        label: B
      }, P)), z = ($) => typeof $ == "function" && $.__emotion_real !== $ || (0, o.isPlainObject)($) ? (ce) => {
        const O = M({
          theme: ce.theme,
          defaultTheme: T,
          themeId: E
        });
        return q($, (0, r.default)({}, ce, {
          theme: O
        }), O.modularCssLayers ? Y : void 0);
      } : $, G = ($, ...ce) => {
        let O = z($);
        const be = ce ? ce.map(z) : [];
        V && _ && be.push((me) => {
          const Oe = M((0, r.default)({}, me, {
            defaultTheme: T,
            themeId: E
          }));
          if (!Oe.components || !Oe.components[V] || !Oe.components[V].styleOverrides)
            return null;
          const Le = Oe.components[V].styleOverrides, We = {};
          return Object.entries(Le).forEach(([Gr, Kr]) => {
            We[Gr] = q(Kr, (0, r.default)({}, me, {
              theme: Oe
            }), Oe.modularCssLayers ? "theme" : void 0);
          }), _(me, We);
        }), V && !F && be.push((me) => {
          var Oe;
          const Le = M((0, r.default)({}, me, {
            defaultTheme: T,
            themeId: E
          })), We = Le == null || (Oe = Le.components) == null || (Oe = Oe[V]) == null ? void 0 : Oe.variants;
          return q({
            variants: We
          }, (0, r.default)({}, me, {
            theme: Le
          }), Le.modularCssLayers ? "theme" : void 0);
        }), N || be.push(W);
        const Fe = be.length - ce.length;
        if (Array.isArray($) && Fe > 0) {
          const me = new Array(Fe).fill("");
          O = [...$, ...me], O.raw = [...$.raw, ...me];
        }
        const Ie = D(O, ...be);
        if (process.env.NODE_ENV !== "production") {
          let me;
          V && (me = `${V}${(0, i.default)(X || "")}`), me === void 0 && (me = `Styled(${(0, s.default)(U)})`), Ie.displayName = me;
        }
        return U.muiName && (Ie.muiName = U.muiName), Ie;
      };
      return D.withConfig && (G.withConfig = D.withConfig), G;
    };
  }
  return Ge;
}
var Xs = /* @__PURE__ */ Hs();
const Js = /* @__PURE__ */ St(Xs);
function Zs(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Qs = (e) => Zs(e) && e !== "classes", ec = Js({
  themeId: Do,
  defaultTheme: Ws,
  rootShouldForwardProp: Qs
});
process.env.NODE_ENV !== "production" && (L.node, L.object.isRequired);
function rc(e) {
  return ds(e);
}
function tc(e) {
  return At("MuiSvgIcon", e);
}
es("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const nc = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], oc = (e) => {
  const {
    color: r,
    fontSize: n,
    classes: t
  } = e, o = {
    root: ["root", r !== "inherit" && `color${Ke(r)}`, `fontSize${Ke(n)}`]
  };
  return us(o, tc, t);
}, ic = ec("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: n
    } = e;
    return [r.root, n.color !== "inherit" && r[`color${Ke(n.color)}`], r[`fontSize${Ke(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: r
}) => {
  var n, t, o, i, s, u, l, d, y, m, h, x, g;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: r.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (t = n.create) == null ? void 0 : t.call(n, "fill", {
      duration: (o = e.transitions) == null || (o = o.duration) == null ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((i = e.typography) == null || (s = i.pxToRem) == null ? void 0 : s.call(i, 20)) || "1.25rem",
      medium: ((u = e.typography) == null || (l = u.pxToRem) == null ? void 0 : l.call(u, 24)) || "1.5rem",
      large: ((d = e.typography) == null || (y = d.pxToRem) == null ? void 0 : y.call(d, 35)) || "2.1875rem"
    }[r.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (m = (h = (e.vars || e).palette) == null || (h = h[r.color]) == null ? void 0 : h.main) != null ? m : {
      action: (x = (e.vars || e).palette) == null || (x = x.action) == null ? void 0 : x.active,
      disabled: (g = (e.vars || e).palette) == null || (g = g.action) == null ? void 0 : g.disabled,
      inherit: void 0
    }[r.color]
  };
}), Ir = /* @__PURE__ */ ie.forwardRef(function(r, n) {
  const t = rc({
    props: r,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: i,
    color: s = "inherit",
    component: u = "svg",
    fontSize: l = "medium",
    htmlColor: d,
    inheritViewBox: y = !1,
    titleAccess: m,
    viewBox: h = "0 0 24 24"
  } = t, x = qe(t, nc), g = /* @__PURE__ */ ie.isValidElement(o) && o.type === "svg", a = te({}, t, {
    color: s,
    component: u,
    fontSize: l,
    instanceFontSize: r.fontSize,
    inheritViewBox: y,
    viewBox: h,
    hasSvgAsChild: g
  }), b = {};
  y || (b.viewBox = h);
  const R = oc(a);
  return /* @__PURE__ */ ir.jsxs(ic, te({
    as: u,
    className: Za(R.root, i),
    focusable: "false",
    color: d,
    "aria-hidden": m ? void 0 : !0,
    role: m ? "img" : void 0,
    ref: n
  }, b, x, g && o.props, {
    ownerState: a,
    children: [g ? o.props.children : o, m ? /* @__PURE__ */ ir.jsx("title", {
      children: m
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Ir.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: L.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: L.object,
  /**
   * @ignore
   */
  className: L.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: L.oneOfType([L.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), L.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: L.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: L.oneOfType([L.oneOf(["inherit", "large", "medium", "small"]), L.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: L.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: L.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: L.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: L.oneOfType([L.arrayOf(L.oneOfType([L.func, L.object, L.bool])), L.func, L.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: L.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: L.string
});
Ir.muiName = "SvgIcon";
function lc(e, r) {
  function n(t, o) {
    return /* @__PURE__ */ ir.jsx(Ir, te({
      "data-testid": `${r}Icon`,
      ref: o
    }, t, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${r}Icon`), n.muiName = Ir.muiName, /* @__PURE__ */ ie.memo(/* @__PURE__ */ ie.forwardRef(n));
}
export {
  lc as A,
  es as B,
  Ja as C,
  fs as D,
  rc as E,
  js as F,
  Zn as G,
  ec as H,
  kr as I,
  Sn as J,
  Ci as K,
  qs as L,
  St as M,
  Ls as N,
  Qs as O,
  Hn as P,
  Fr as Q,
  Zs as R,
  cc as S,
  Dr as T,
  Ue as U,
  lo as V,
  Bi as W,
  sc as X,
  Yi as Y,
  Jn as Z,
  qe as _,
  Vr as a,
  te as b,
  ao as c,
  Za as d,
  Ka as e,
  Hi as f,
  Ke as g,
  is as h,
  Xi as i,
  ir as j,
  ze as k,
  pr as l,
  ss as m,
  us as n,
  L as o,
  At as p,
  Ye as q,
  vt as r,
  Ki as s,
  fc as t,
  to as u,
  je as v,
  uc as w,
  Er as x,
  Do as y,
  Ws as z
};
//# sourceMappingURL=createSvgIcon-CU4sOtbo.js.map
